export const PaymentMethodsIcon = ({
  width = "36px",
  height = "36px",
  color = "#343434",
  className = "",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.0434 9.78107V26.2189C31.0434 26.9483 30.7907 27.5657 30.2854 28.071C29.78 28.5764 29.1626 28.8291 28.4332 28.8291H6.21988C5.49048 28.8291 4.8731 28.5764 4.36775 28.071C3.86239 27.5657 3.60971 26.9483 3.60971 26.2189V9.78107C3.60971 9.05167 3.86239 8.43429 4.36775 7.92893C4.8731 7.42358 5.49048 7.1709 6.21988 7.1709H28.4332C29.1626 7.1709 29.78 7.42358 30.2854 7.92893C30.7907 8.43429 31.0434 9.05167 31.0434 9.78107ZM5.77553 12.8078H28.8776V9.78107C28.8776 9.66989 28.8313 9.5681 28.7386 9.47569C28.6462 9.38304 28.5444 9.33672 28.4332 9.33672H6.21988C6.1087 9.33672 6.00691 9.38304 5.9145 9.47569C5.82185 9.5681 5.77553 9.66989 5.77553 9.78107V12.8078ZM5.77553 17.4167V26.2189C5.77553 26.3301 5.82185 26.4319 5.9145 26.5243C6.00691 26.6169 6.1087 26.6633 6.21988 26.6633H28.4332C28.5444 26.6633 28.6462 26.6169 28.7386 26.5243C28.8313 26.4319 28.8776 26.3301 28.8776 26.2189V17.4167H5.77553Z"
        fill={color}
      />
    </svg>
  );
};

export const IconStripe = ({
  width = "101px",
  height = "41px",
  color = "#26317F",
  className = "",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 101 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5797 18.3742C8.42637 17.5893 7.24628 16.9787 7.24628 16.0193C7.24628 15.2051 7.92482 14.74 9.13433 14.74C11.3467 14.74 13.618 15.5832 15.1815 16.339L16.0664 10.9606C14.8275 10.3791 12.2905 9.41967 8.78035 9.41967C6.30247 9.41967 4.23743 10.0592 2.76265 11.2513C1.22858 12.5013 0.432119 14.3039 0.432119 16.4844C0.432119 20.4383 2.88057 22.1247 6.86287 23.5492C9.42924 24.4504 10.2848 25.0901 10.2848 26.0785C10.2848 27.0379 9.45867 27.5903 7.95424 27.5903C6.09584 27.5903 3.02814 26.6891 1.02216 25.5262L0.137207 30.9628C1.84805 31.9222 5.03389 32.9106 8.33787 32.9106C10.9631 32.9106 13.1461 32.3001 14.6211 31.1372C16.2728 29.858 17.1284 27.9684 17.1284 25.5262C17.1284 21.4849 14.6211 19.7988 10.5797 18.3742ZM31.5348 15.2051L32.4197 9.85577H27.7478V3.36186L21.4664 4.38058L20.5593 9.85577L18.35 10.209L17.523 15.2051H20.5503V25.7007C20.5503 28.4335 21.2582 30.3233 22.7036 31.4861C23.9131 32.4455 25.6534 32.9106 28.1018 32.9106C29.9896 32.9106 31.1401 32.591 31.9365 32.3873V26.7181C31.4941 26.8345 30.4912 27.0379 29.8126 27.0379C28.3673 27.0379 27.7478 26.3112 27.7478 24.654V15.2051H31.5348ZM45.5649 9.54331C43.5 9.54331 41.848 10.6117 41.1992 12.5306L40.7567 9.85577H34.3556V32.4745H41.6711V17.7927C42.5857 16.6879 43.8834 16.2884 45.6534 16.2884C46.037 16.2884 46.4498 16.2884 46.9514 16.3756V9.71774C46.4498 9.60153 46.0073 9.54331 45.5649 9.54331ZM52.4087 7.61707C54.5326 7.61707 56.2434 5.90191 56.2434 3.80864C56.2434 1.68617 54.5326 0 52.4087 0C50.2551 0 48.5443 1.68617 48.5443 3.80864C48.5443 5.90191 50.2551 7.61707 52.4087 7.61707ZM48.7213 9.85577H56.0664V32.4745H48.7213V9.85577ZM76.8812 11.8908C75.5832 10.2336 73.7839 9.41967 71.483 9.41967C69.3591 9.41967 67.5007 10.2919 65.7602 12.1235L65.3768 9.85577H58.9461V40.8476L66.2618 39.6557V32.3873C67.3826 32.7362 68.533 32.9106 69.5655 32.9106C71.3945 32.9106 74.0494 32.4455 76.1142 30.2361C78.0905 28.1136 79.0936 24.8285 79.0936 20.4965C79.0936 16.6589 78.356 13.7516 76.8812 11.8908ZM70.8045 25.8459C70.2144 26.9507 69.3 27.5323 68.2381 27.5323C67.5007 27.5323 66.8516 27.3868 66.2618 27.0962V16.339C67.5007 15.0599 68.6215 14.9145 69.0346 14.9145C70.893 14.9145 71.8073 16.8915 71.8073 20.7582C71.8073 22.9676 71.483 24.683 70.8045 25.8459ZM100.067 20.9616C100.067 17.3566 99.2706 14.5074 97.7071 12.5013C96.1142 10.4663 93.7248 9.41967 90.6865 9.41967C84.4622 9.41967 80.5981 13.9551 80.5981 21.2233C80.5981 25.2936 81.6304 28.3462 83.6657 30.2941C85.4947 32.0384 88.1202 32.9106 91.5124 32.9106C94.6392 32.9106 97.5301 32.1839 99.3591 30.9918L98.5627 26.0495C96.7631 27.0089 94.6688 27.5323 92.3089 27.5323C90.893 27.5323 89.9195 27.2414 89.2115 26.6309C88.4445 25.9913 88.002 24.9447 87.8547 23.462H99.9786C100.008 23.1131 100.067 21.4849 100.067 20.9616ZM87.7956 19.0428C88.002 15.8157 88.887 14.3039 90.5684 14.3039C92.2204 14.3039 93.0759 15.8449 93.1938 19.0428H87.7956Z"
        fill={color}
      />
    </svg>
  );
};

export const IconHome = ({
  width = "22px",
  height = "22px",
  color = "#6A6A6A",
  className = ""
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7708 8.17673L12.3368 0.456376C11.9931 0.152125 11.4965 0 11 0C10.4653 0 9.96875 0.152125 9.625 0.456376L0.190972 8.17673C0.0763889 8.29083 0 8.44295 0 8.63311C0 8.78524 0.0381944 8.93736 0.114583 9.01342L0.534722 9.50783C0.611111 9.62192 0.802083 9.69799 0.993056 9.69799C1.14583 9.69799 1.26042 9.65996 1.375 9.58389L2.44444 8.70917V15.783C2.44444 16.4676 2.97917 17 3.66667 17H8.55556C9.20486 17 9.73958 16.4676 9.77778 15.783V11.8277H12.2222V15.783C12.2222 16.4676 12.7569 17 13.4444 17H18.3333C18.9826 17 19.5174 16.4676 19.5556 15.821V8.70917L20.5868 9.58389C20.7014 9.65996 20.816 9.73602 20.9688 9.73602C21.1597 9.73602 21.3507 9.62192 21.4653 9.50783L21.8472 9.01342C21.9236 8.93736 22 8.78524 22 8.63311C22 8.44295 21.8854 8.29083 21.7708 8.17673ZM17.684 15.1745H14.0556V11.2192C14.0174 10.5727 13.4826 10.0403 12.8333 10.0022H9.16667C8.47917 10.0403 7.94444 10.5727 7.94444 11.2192V15.1745H4.27778V7.22595L11 1.71141L17.7222 7.22595L17.684 15.1745Z"
        fill={color}
      />
    </svg>
  );
};

export const IconOrders = ({
  width = "22px",
  height = "22px",
  color = "#6A6A6A",
  className = "",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2891 10.3125L10.1406 9.71094C9.96875 9.66797 9.88281 9.53906 9.88281 9.36719C9.88281 9.15234 10.0547 8.98047 10.2266 8.98047H11.6445C11.8164 8.98047 11.9453 9.02344 12.0742 9.10938C12.2891 9.19531 12.5469 9.15234 12.6758 9.02344L13.4492 8.25C13.6641 8.03516 13.6641 7.64844 13.3633 7.47656C12.9766 7.17578 12.5039 7.04688 12.0312 6.96094V6.1875C12.0312 5.84375 11.6875 5.5 11.3438 5.5H10.6562C10.2695 5.5 9.96875 5.84375 9.96875 6.1875V6.96094C8.63672 7.13281 7.64844 8.29297 7.82031 9.66797C7.94922 10.6562 8.72266 11.4297 9.66797 11.7305L11.8164 12.332C11.9883 12.375 12.0742 12.5039 12.0742 12.6758C12.0742 12.8906 11.9453 13.0625 11.7305 13.0625H10.3125C10.1406 13.0625 10.0117 13.0195 9.88281 12.9336C9.66797 12.8477 9.41016 12.8906 9.28125 13.0195L8.50781 13.793C8.29297 14.0078 8.33594 14.3945 8.59375 14.5664C8.98047 14.8672 9.45312 14.9961 9.96875 15.082V15.8125C9.96875 16.1992 10.2695 16.5 10.6562 16.5H11.3438C11.6875 16.5 12.0312 16.1992 12.0312 15.8125V15.082C13.3203 14.9102 14.3086 13.75 14.1367 12.375C14.0078 11.3867 13.2344 10.6133 12.2891 10.3125ZM22 11C22 9.45312 21.1836 8.07812 19.9805 7.30469C20.2812 5.88672 19.8516 4.33984 18.7773 3.22266C17.6602 2.14844 16.1133 1.71875 14.6953 2.01953C13.9219 0.816406 12.5469 0 11 0C9.41016 0 8.03516 0.816406 7.26172 2.01953C5.84375 1.71875 4.29688 2.14844 3.22266 3.22266C2.10547 4.33984 1.67578 5.88672 1.97656 7.30469C0.773438 8.07812 0 9.45312 0 11C0 12.5898 0.773438 13.9648 1.97656 14.7383C1.67578 16.1562 2.10547 17.7031 3.22266 18.7773C4.29688 19.8945 5.84375 20.3242 7.26172 20.0234C8.03516 21.2266 9.41016 22 11 22C12.5469 22 13.9219 21.2266 14.6953 20.0234C16.1133 20.3242 17.6602 19.8945 18.7773 18.7773C19.8516 17.7031 20.2812 16.1562 19.9805 14.7383C21.1836 13.9648 22 12.5898 22 11ZM17.3164 13.6641C17.7031 14.5234 18.6484 16.0273 17.3164 17.3594C16.1133 18.5625 14.9102 17.9609 13.6211 17.3594C13.2773 18.2617 12.8477 19.9375 11 19.9375C9.02344 19.9375 8.63672 18.1328 8.33594 17.3594C7.43359 17.7891 5.97266 18.6484 4.64062 17.3164C3.26562 15.9414 4.29688 14.3945 4.64062 13.6641C3.73828 13.3203 2.0625 12.8906 2.0625 11C2.0625 9.06641 3.86719 8.67969 4.64062 8.37891C4.25391 7.51953 3.35156 6.01562 4.68359 4.68359C6.05859 3.30859 7.60547 4.33984 8.33594 4.68359C8.67969 3.78125 9.10938 2.0625 11 2.0625C12.9336 2.0625 13.3203 3.91016 13.6211 4.68359C14.4805 4.29688 15.9844 3.39453 17.3164 4.72656C18.6914 6.10156 17.6602 7.64844 17.3164 8.37891C18.2188 8.72266 19.8945 9.15234 19.8945 11.043C19.8945 12.9766 18.0898 13.3633 17.3164 13.6641Z"
        fill={color}
      />
    </svg>
  );
};

export const IconProducts = ({
  width = "22px",
  height = "22px",
  color = "#6A6A6A",
  className = "",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9401 9.36431L22.9086 5.34546C22.7524 5.03332 22.4398 4.9943 22.2836 5.03332L20.2911 5.26742L21.1506 2.88733C21.3069 2.49715 21.2678 2.10697 21.1116 1.71679C20.9162 1.32661 20.6037 1.05348 20.213 0.897413L18.0643 0.117054C17.2439 -0.19509 16.3454 0.234108 16.0328 1.05348L14.8218 4.37001C14.2748 1.87286 12.048 0 9.39147 0C6.42238 0 4.03929 2.26304 3.80489 5.15037L2.71101 5.03332C2.55475 4.9943 2.24221 5.03332 2.08594 5.34546L0.0544601 9.36431C-0.101808 9.71547 0.093527 10.1447 0.44513 10.2617L2.51568 10.847V16.5826C2.51568 17.1679 2.90635 17.6751 3.45329 17.7922L11.8918 19.9382C12.4387 20.0552 12.8684 19.9772 13.1028 19.9382L21.5413 17.7922C22.1273 17.6751 22.518 17.1679 22.518 16.5826V10.847L24.5494 10.2617C24.9401 10.1447 25.0964 9.71547 24.9401 9.36431ZM17.7127 1.98992L19.2754 2.53617L18.1815 5.54055L16.3063 5.77466L17.7127 1.98992ZM2.39848 8.8961L3.37515 6.98421L9.39147 7.76457L7.78972 10.4178L2.39848 8.8961ZM11.5792 17.9092L4.39089 16.1144V11.3932L8.18039 12.4857C8.49292 12.5638 8.80546 12.4077 8.92266 12.1736L11.5792 7.80359V17.9092ZM13.0638 6.20386L12.5168 6.24287L5.64104 5.38448C5.7973 3.43358 7.39905 1.87286 9.39147 1.87286C11.4229 1.87286 13.1419 3.58965 13.1419 5.61859C13.1419 5.81368 13.1028 6.00877 13.0638 6.20386ZM20.6428 16.1144L13.4544 17.9092V7.80359L16.0719 12.2126C16.2282 12.4077 16.5017 12.5638 16.8142 12.4857L20.6428 11.3932V16.1144ZM17.2049 10.4178L15.6031 7.76457L21.6585 6.98421L22.5961 8.8961L17.2049 10.4178Z"
        fill={color}
      />
    </svg>
  )
}

export const IconAds = ({
  width = "25px",
  height = "20px",
  color = "#6A6A6A",
  className = "",
}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 24 30" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M14.2099 1.11737C11.8314 0.291296 10.5646 1.13308 9.91989 1.98491C9.90093 2.01004 9.88449 2.03642 9.87058 2.06406L4.8277 12.2044C4.3669 12.5757 3.86375 12.8954 3.33278 13.2334C2.89474 13.5117 2.44152 13.7994 2.01612 14.1185C-0.457917 15.9742 -0.282825 18.7062 0.927013 20.4589C1.59198 21.4219 2.55151 22.1079 3.62797 22.39C4.69622 22.6695 5.8005 22.537 6.84852 22.0074L11.2587 28.4872C11.2719 28.5067 11.2859 28.5249 11.3017 28.5419C11.8301 29.1255 12.4989 29.4088 13.0222 29.591C13.076 29.6098 13.1322 29.6193 13.1891 29.6193H14.0721C14.1221 29.6193 14.172 29.6117 14.2194 29.5973L14.679 29.4584C14.6891 29.4553 14.6986 29.4522 14.7087 29.4484C15.5702 29.1286 16.2181 28.5029 16.5323 27.6863C16.854 26.8495 16.7832 25.8853 16.3376 25.0397C16.3287 25.0227 16.3193 25.007 16.3085 24.9913L12.7081 19.7076L20.6864 19.0857C22.431 19.0649 23.723 17.7344 23.9045 15.7688C24.1206 13.4225 23.041 10.2099 21.0151 7.17444C19.0057 4.1635 16.4615 1.89885 14.2093 1.11675L14.2099 1.11737ZM7.99894 18.4832C7.7973 18.6252 7.59692 18.7728 7.40034 18.9173C6.93701 19.2584 6.45725 19.6108 6.00024 19.8646C5.16903 20.3257 4.22215 20.3062 3.46616 19.8131C2.71016 19.3187 2.3151 18.4713 2.40992 17.546C2.52306 16.4422 3.62165 15.7656 4.68484 15.1111C4.92378 14.9641 5.16777 14.8139 5.39975 14.6588L7.99894 18.4832ZM18.5961 16.13C17.1732 15.3159 15.6492 13.8295 14.3048 11.9456C13.0121 10.1332 12.0463 8.16008 11.6556 6.53179C11.2884 5.00277 11.3421 3.78658 11.7953 3.35878C11.9919 3.17283 12.2473 3.09808 12.5305 3.09808C13.2732 3.09808 14.2112 3.61382 14.8029 3.99514C17.6144 5.80811 20.689 10.1791 21.3824 13.3496C21.7243 14.9151 21.5783 16.1476 21.0006 16.5679C20.5347 16.9058 19.6814 16.7507 18.5967 16.13H18.5961ZM10.0115 19.9293L10.0779 19.9268L14.3515 26.2226C14.5456 26.7069 14.3345 27.0537 14.0658 27.2189C13.8029 27.3804 13.3756 27.4243 13.0267 27.0242L8.74734 20.7617L10.0115 19.9293ZM7.04384 12.9337L9.60763 7.68139L9.84973 8.49302C9.85352 8.50559 9.85794 8.51878 9.863 8.53071C11.2113 12.0065 13.3522 15.0018 15.9571 17.0849L10.2498 17.605C9.2821 16.287 8.3586 14.9025 7.46292 13.5613C7.32322 13.3521 7.18353 13.1429 7.04384 12.9337Z" />
      <path d="M15.3667 6.83167C14.928 6.83167 13.5424 6.99877 12.9527 7.74004C12.7188 8.0334 12.6404 8.37766 12.7258 8.73573C12.782 8.97319 12.9047 9.16981 13.0892 9.31995C13.7169 9.83067 14.275 9.52223 14.6088 9.33817C14.7289 9.27158 14.8427 9.20939 14.9432 9.18363C15.8256 8.95999 16.4621 9.40727 16.763 9.90103C17.0575 10.3841 17.1612 11.1348 16.5683 11.7919C16.5278 11.8371 16.4596 11.8968 16.3875 11.9603C16.1176 12.1977 15.7485 12.5231 15.7478 13.0062C15.7478 13.3021 15.8875 13.576 16.1644 13.821C16.3806 14.0126 16.641 14.1125 16.9153 14.1125C16.9994 14.1125 17.0847 14.103 17.1701 14.0842C18.0259 13.8951 18.7617 12.7738 18.9835 12.2605C19.5088 11.0469 19.3925 9.67237 18.6719 8.58559C17.9444 7.4875 16.7093 6.83229 15.3673 6.83229L15.3667 6.83167Z" fill={color} />
    </svg>
  )
}

export const IconFunnel = ({
  width = "25px",
  height = "20px",
  color = "#6A6A6A",
  className = "",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1667 3.83333H3.83333C2.77917 3.83333 1.92625 4.69583 1.92625 5.75L1.91667 17.25C1.91667 18.3042 2.77917 19.1667 3.83333 19.1667H19.1667C20.2208 19.1667 21.0833 18.3042 21.0833 17.25V5.75C21.0833 4.69583 20.2208 3.83333 19.1667 3.83333ZM14.375 17.25H3.83333V13.4167H14.375V17.25ZM14.375 12.4583H3.83333V8.625H14.375V12.4583ZM19.1667 17.25H15.3333V8.625H19.1667V17.25Z"
        fill={color}
      />
    </svg>
  )
}

export const IconSettings = ({
  width = "25px",
  height = "20px",
  color = "#3C3C3C",
  className = "",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5538 7.20787C19.7622 7.7049 20.2562 8.03005 20.8052 8.03162C21.5503 8.0375 22.1512 8.6303 22.1511 9.35951V11.6512C22.1511 12.3846 21.5436 12.9791 20.7942 12.9791C20.2452 12.9807 19.7513 13.3058 19.5429 13.8028C19.3344 14.2999 19.4526 14.8708 19.8422 15.2494C20.3649 15.7735 20.3649 16.61 19.8422 17.1341L18.2008 18.7404C17.6652 19.2519 16.8104 19.2519 16.2748 18.7404C16.0278 18.4843 15.6827 18.3407 15.3228 18.3442C14.961 18.3414 14.6131 18.48 14.3562 18.7293C14.0994 18.9787 13.9549 19.3181 13.9549 19.6721C13.9549 20.4055 13.3474 21 12.598 21H10.2562C9.50684 21 8.89933 20.4055 8.89933 19.6721C8.89934 19.3181 8.75488 18.9787 8.49804 18.7293C8.2412 18.48 7.89324 18.3414 7.53147 18.3442C7.17157 18.3407 6.82649 18.4843 6.57944 18.7404C6.04384 19.2519 5.1891 19.2519 4.6535 18.7404L3.01207 17.1341C2.4894 16.61 2.4894 15.7735 3.01207 15.2494C3.40169 14.8708 3.51984 14.2999 3.31141 13.8028C3.10298 13.3058 2.60904 12.9807 2.06004 12.9791C1.70016 12.9791 1.35503 12.8392 1.10056 12.5902C0.846085 12.3411 0.703125 12.0034 0.703125 11.6512V9.35951C0.703125 8.62613 1.31064 8.03162 2.06004 8.03162C2.60904 8.03005 3.10298 7.7049 3.31141 7.20787C3.51984 6.71083 3.40169 6.13986 3.01207 5.76135C2.4894 5.2372 2.4894 4.40074 3.01207 3.87659L4.6535 2.27027C5.1891 1.75878 6.04384 1.75878 6.57944 2.27027C6.82649 2.52642 7.17157 2.67004 7.53147 2.6665C7.89515 2.66938 8.24478 2.52927 8.50194 2.27761C8.75911 2.02594 8.90228 1.68379 8.89933 1.32789C8.89933 0.594518 9.50684 0 10.2562 0H12.609C13.3584 0 13.9659 0.594518 13.9659 1.32789C13.9629 1.68379 14.1061 2.02594 14.3633 2.27761C14.6204 2.52927 14.9701 2.66938 15.3337 2.6665C15.6936 2.67004 16.0387 2.52642 16.2858 2.27027C16.8214 1.75878 17.6761 1.75878 18.2117 2.27027L19.8531 3.87659C20.3758 4.40074 20.3758 5.2372 19.8531 5.76135C19.4635 6.13986 19.3454 6.71083 19.5538 7.20787ZM17.9929 13.1826C18.42 12.1633 19.3982 11.4671 20.5207 11.3835L20.4878 9.62723C19.3776 9.53196 18.4147 8.83767 17.9929 7.82815C17.5796 6.81625 17.7689 5.66391 18.4853 4.82968L17.2269 3.59816C16.6932 4.03552 16.0189 4.27445 15.3228 4.27282C13.772 4.2691 12.4761 3.11664 12.3244 1.60632H10.5298C10.383 3.11905 9.08421 4.2741 7.53147 4.27282C6.83539 4.27445 6.16108 4.03552 5.62741 3.59816L4.40181 4.82968C5.10711 5.67028 5.28365 6.82204 4.86141 7.82815C4.43954 8.83767 3.4767 9.53196 2.36644 9.62723V11.3835C3.4767 11.4788 4.43954 12.173 4.86141 13.1826C5.27466 14.1945 5.08541 15.3468 4.36898 16.181L5.62741 17.4125C6.16108 16.9752 6.83539 16.7363 7.53147 16.7379C9.08224 16.7416 10.3781 17.8941 10.5298 19.4044H12.3244C12.4613 17.8868 13.7661 16.7264 15.3228 16.7379C16.0189 16.7363 16.6932 16.9752 17.2269 17.4125L18.4525 16.181C17.7472 15.3404 17.5706 14.1887 17.9929 13.1826Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6409 10.5054C7.6409 8.459 9.33605 6.8001 11.4271 6.8001C12.4313 6.8001 13.3943 7.19048 14.1044 7.88535C14.8145 8.58022 15.2134 9.52266 15.2134 10.5054C15.2134 12.5517 13.5182 14.2106 11.4271 14.2106C9.33605 14.2106 7.6409 12.5517 7.6409 10.5054ZM9.23856 10.5054C9.23856 11.6882 10.2184 12.6471 11.4271 12.6471C12.6359 12.6471 13.6157 11.6882 13.6157 10.5054C13.6157 9.32249 12.6359 8.36359 11.4271 8.36359C10.2184 8.36359 9.23856 9.32249 9.23856 10.5054Z"
        fill={color}
      />
    </svg>
  )
}

export const IconCalculator = ({
  width = "42px",
  height = "42px",
  color = "#6A6A6A",
  className = "",
}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 33 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M29.4643 0.000671387H3.53571C1.62054 0.000671387 0 1.7077 0 3.56317V34.4382C0 36.3679 1.62054 38.0007 3.53571 38.0007H29.4643C31.3058 38.0007 33 36.3679 33 34.4382V3.56317C33 1.7077 31.3058 0.000671387 29.4643 0.000671387ZM29.4643 34.4382H3.53571V15.4382H29.4643V34.4382ZM29.4643 11.8757H3.53571V3.56317H29.4643V11.8757ZM7.95536 23.7507H10.8281C11.2701 23.7507 11.7857 23.3054 11.7857 22.86V19.9655C11.7857 19.5202 11.2701 19.0007 10.8281 19.0007H7.95536C7.51339 19.0007 7.07143 19.5202 7.07143 19.9655V22.86C7.07143 23.3054 7.51339 23.7507 7.95536 23.7507ZM22.0982 30.8757H24.971C25.4129 30.8757 25.9286 30.4304 25.9286 29.985V19.9655C25.9286 19.5202 25.4129 19.0007 24.971 19.0007H22.0982C21.6562 19.0007 21.2143 19.5202 21.2143 19.9655V29.985C21.2143 30.4304 21.6562 30.8757 22.0982 30.8757ZM7.95536 30.8757H10.8281C11.2701 30.8757 11.7857 30.4304 11.7857 29.985V27.0905C11.7857 26.6452 11.2701 26.1257 10.8281 26.1257H7.95536C7.51339 26.1257 7.07143 26.6452 7.07143 27.0905V29.985C7.07143 30.4304 7.51339 30.8757 7.95536 30.8757ZM15.0268 23.7507H17.8996C18.3415 23.7507 18.8571 23.3054 18.8571 22.86V19.9655C18.8571 19.5202 18.3415 19.0007 17.8996 19.0007H15.0268C14.5848 19.0007 14.1429 19.5202 14.1429 19.9655V22.86C14.1429 23.3054 14.5848 23.7507 15.0268 23.7507ZM15.0268 30.8757H17.8996C18.3415 30.8757 18.8571 30.4304 18.8571 29.985V27.0905C18.8571 26.6452 18.3415 26.1257 17.8996 26.1257H15.0268C14.5848 26.1257 14.1429 26.6452 14.1429 27.0905V29.985C14.1429 30.4304 14.5848 30.8757 15.0268 30.8757Z" fill={color} />
    </svg>
  )
}

export const IconComments = ({
  width = "42px",
  height = "41px",
  color = "#6A6A6A",
  className = "",
}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M36.3433 0.000183105H5.59326C2.71045 0.000183105 0.468262 2.32245 0.468262 5.12518V28.1877C0.468262 31.0705 2.71045 33.3127 5.59326 33.3127H13.2808V40.0392C13.2808 40.6799 13.6812 41.0002 14.2417 41.0002C14.4019 41.0002 14.562 41.0002 14.8022 40.84L24.812 33.3127H36.3433C39.146 33.3127 41.4683 31.0705 41.4683 28.1877V5.12518C41.4683 2.32245 39.146 0.000183105 36.3433 0.000183105ZM37.6245 28.1877C37.6245 28.9084 36.9839 29.4689 36.3433 29.4689H23.5308L22.4897 30.2697L17.1245 34.2736V29.4689H5.59326C4.87256 29.4689 4.31201 28.9084 4.31201 28.1877V5.12518C4.31201 4.48456 4.87256 3.84393 5.59326 3.84393H36.3433C36.9839 3.84393 37.6245 4.48456 37.6245 5.12518V28.1877ZM29.937 10.8908H11.9995C11.2788 10.8908 10.7183 11.5314 10.7183 12.1721V13.4533C10.7183 14.174 11.2788 14.7346 11.9995 14.7346H29.937C30.5776 14.7346 31.2183 14.174 31.2183 13.4533V12.1721C31.2183 11.5314 30.5776 10.8908 29.937 10.8908ZM22.2495 18.5783H11.9995C11.2788 18.5783 10.7183 19.2189 10.7183 19.8596V21.1408C10.7183 21.8615 11.2788 22.4221 11.9995 22.4221H22.2495C22.8901 22.4221 23.5308 21.8615 23.5308 21.1408V19.8596C23.5308 19.2189 22.8901 18.5783 22.2495 18.5783Z" fill={color} />
    </svg>
  )
}

export const IconCredit = ({
  width = "30px",
  height = "25px",
  color = "",
  className = "",
}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 26 19" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M9.20735 5.76868L9.54791 5.03547C12.4934 -0.807514 20.7724 -1.04858 23.961 4.68623C25.0288 6.60673 25.2619 9.28182 24.944 11.4347C23.6545 20.1538 12.3859 21.1214 9.34357 13.1562L8.8581 11.5182C8.66378 12.9893 8.28783 14.4971 7.7456 15.8794C7.2855 17.0506 6.41473 18.9745 4.93162 18.9177C4.16702 18.8884 2.95702 18.7361 2.19109 18.6099C0.884934 18.3949 0.570414 16.9104 0.374758 15.7772C-0.264965 12.0657 0.428847 5.52762 2.06689 2.10263C2.50695 1.18044 3.08523 0.171436 4.23313 0.221518C5.0044 0.254907 6.15564 0.400481 6.92624 0.527357C7.83708 0.677605 8.25778 1.24922 8.58165 2.07124C9.03706 3.22581 9.08782 4.54666 9.20801 5.76868H9.20735ZM3.89657 0.929354C3.21745 1.04354 2.45486 2.98141 2.24585 3.58174C1.60679 5.41944 1.2048 7.60638 1.01047 9.54425C0.827506 11.3706 0.624504 16.081 1.68826 17.5635C2.135 18.1859 2.55436 17.7204 2.88023 17.2623C4.14632 15.4821 4.82878 11.5743 5.05849 9.394C5.2468 7.60571 5.47318 2.55938 4.3353 1.17109C4.22846 1.04087 4.08088 0.899972 3.89724 0.93069L3.89657 0.929354ZM8.25711 3.66921C8.15361 3.00144 7.83441 1.53369 7.10855 1.29462C7.00838 1.2619 6.84077 1.24521 6.72658 1.22718C6.19704 1.14371 5.64212 1.12434 5.10858 1.07159C5.47852 1.79345 5.66416 2.61213 5.76032 3.41813L8.25778 3.66988L8.25711 3.66921ZM16.3445 1.23519C10.5549 1.62517 7.4037 8.2835 10.8367 13.0113C14.0006 17.3685 20.6816 17.0039 23.3113 12.3008C26.1954 7.14161 22.2315 0.838537 16.3445 1.23519ZM8.34793 4.42913L5.85781 4.16937L5.91057 6.06651L8.50686 6.36901L8.34793 4.42913ZM8.50485 7.0715L5.9079 6.81908L5.85781 8.71889L8.45744 8.96863L8.50418 7.0715H8.50485ZM8.40736 9.66846L5.75832 9.41871L5.5079 11.3172L8.15427 11.5643L8.40669 9.66779L8.40736 9.66846ZM8.00736 12.2674L5.35899 12.0177L4.95833 13.8661L7.56063 14.1465L8.00803 12.2674H8.00736ZM21.903 15.9662C22.8626 15.1255 23.557 13.9729 23.903 12.7429L23.3727 13.5128C22.9394 14.0771 22.4399 14.5766 21.9023 15.042V15.9669L21.903 15.9662ZM11.8564 15.0166C11.4263 14.7983 11.1319 14.3862 10.7813 14.0677L10.2564 13.4427C10.5943 14.3081 11.1699 15.1448 11.8571 15.7665V15.0166H11.8564ZM7.35762 14.867L4.75867 14.5665C4.54899 15.5208 4.15033 16.4216 3.69891 17.281L3.20877 18.0156L5.0832 18.2199C5.69555 18.2206 6.24779 17.3271 6.51623 16.8497C6.86882 16.2226 7.10454 15.5388 7.35762 14.867ZM13.7555 17.1154V16.1906L12.5562 15.5655V16.3902C12.5562 16.4603 13.7094 17.1675 13.7555 17.1148V17.1154ZM21.2038 15.5662L20.0045 16.1912V17.2163C20.1835 17.1889 21.2038 16.6366 21.2038 16.5411V15.5662ZM15.6052 16.666C15.2166 16.6306 14.8186 16.5558 14.4553 16.4163V17.466L15.6052 17.7658V16.666ZM19.304 16.4156L18.1541 16.6653V17.7652C18.5488 17.7491 18.9274 17.6176 19.304 17.5154V16.4156ZM17.4543 16.7655H16.3044V17.8653H17.4543V16.7655Z" fill="#4F46E5" />
      <path d="M16.8381 2.18863C21.7121 2.17394 24.8666 7.45399 22.5114 11.7504C20.2143 15.9413 14.2471 16.2505 11.536 12.312C8.59177 8.03562 11.6829 2.20399 16.8381 2.18863ZM16.2451 2.93453C12.0034 3.30981 9.68624 8.29338 12.0655 11.8326C14.5803 15.5727 20.2797 15.1133 22.0961 10.9852C23.895 6.89574 20.6544 2.54388 16.2451 2.93453Z" fill="#4F46E5" />
      <g clipPath="url(#clip0_2091_2115)">
        <path d="M15.9138 12.5035C15.8353 12.0524 15.6872 10.6904 15.539 9.89234C15.5128 9.72751 15.4431 9.44991 15.3821 9.27642C15.2775 8.97279 15.0945 8.79929 15.0422 8.74724C14.9289 8.63447 14.7285 8.40025 13.5257 8.16602C12.8721 8.0359 12.4276 7.9665 12.1574 7.92312C12.1051 7.91445 12.1051 7.84505 12.1574 7.83637C12.4276 7.793 12.8721 7.7236 13.5344 7.59348C14.7372 7.35058 14.9289 7.12503 15.0422 7.01225C15.1555 6.89948 15.3908 6.69995 15.6261 5.50281C15.7569 4.85219 15.8353 4.40977 15.8702 4.14084C15.8789 4.08879 15.9486 4.08879 15.9573 4.14084C16.0009 4.40977 16.0706 4.85219 16.2014 5.51149C16.4454 6.70863 16.672 6.89948 16.7853 7.02093C16.8986 7.1337 17.0904 7.35925 18.2931 7.60215C18.9555 7.73227 19.4 7.81035 19.6701 7.84505C19.7224 7.85372 19.7224 7.92312 19.6701 7.9318C19.4 7.97517 18.9555 8.04457 18.2931 8.1747C17.0904 8.4176 16.8986 8.64314 16.7766 8.75592C16.7243 8.80797 16.5413 8.98147 16.4367 9.28509C16.3757 9.47594 16.3147 9.73619 16.3147 9.83161C16.2624 10.3087 16.0271 11.8355 15.9138 12.5035Z" fill="#4F46E5" />
        <path d="M21.3784 10.6644C21.2302 10.6471 20.9949 10.6037 20.6376 10.5343C19.9926 10.4042 19.888 10.2827 19.827 10.222C19.8096 10.2046 19.7835 10.1786 19.7486 10.1352C19.6876 10.0398 19.6004 9.84895 19.5133 9.42388C19.4435 9.06821 19.4 8.83399 19.3825 8.68651C19.3825 8.66049 19.339 8.66049 19.339 8.68651C19.3215 8.83399 19.278 9.06821 19.2082 9.42388C19.1211 9.84895 19.0426 10.0398 18.9729 10.1352C18.938 10.1786 18.9032 10.2133 18.8945 10.222C18.8335 10.2827 18.7289 10.4042 18.0839 10.5343C17.7266 10.6037 17.4913 10.6471 17.3431 10.6644C17.3257 10.6644 17.3257 10.6818 17.3257 10.6904C17.3257 10.6991 17.3344 10.7164 17.3431 10.7164C17.4913 10.7338 17.7266 10.7772 18.0839 10.8466C18.7289 10.9767 18.8335 11.0981 18.8945 11.1589C18.9119 11.1762 18.938 11.2022 18.9729 11.2456C19.0339 11.341 19.1211 11.5319 19.2082 11.957C19.278 12.3126 19.3215 12.5469 19.339 12.6943C19.339 12.7204 19.3825 12.7204 19.3825 12.6943C19.4 12.5469 19.4435 12.3126 19.5133 11.957C19.6004 11.5319 19.6789 11.341 19.7486 11.2456C19.7835 11.2022 19.8183 11.1675 19.827 11.1589C19.888 11.0981 19.9926 10.9767 20.6376 10.8466C20.9949 10.7772 21.2302 10.7338 21.3784 10.7164C21.3958 10.7164 21.3958 10.6991 21.3958 10.6904C21.4045 10.6818 21.3958 10.6644 21.3784 10.6644Z" fill="#4F46E5" />
      </g>
      <defs>
        <clipPath id="clip0_2091_2115">
          <rect width="9.282" height="8.61423" fill="white" transform="translate(12.1226 4.1062)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconPlusCircle = ({
  width = "30px",
  height = "30px",
  color = "#6A6A6A",
  className = "",
}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 31 31" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M14.1517 22.9743H17.0003V17.0111H22.9635V14.1625H17.0003V8.16136H14.1517V14.1625H8.15055V17.0111H14.1517V22.9743ZM15.557 30.3808C13.5083 30.3808 11.583 29.9913 9.78112 29.2125C7.97951 28.4333 6.41225 27.3762 5.07934 26.041C3.74642 24.7055 2.69065 23.1378 1.91202 21.3377C1.13339 19.5378 0.74408 17.6146 0.74408 15.5678C0.74408 13.5191 1.13352 11.5938 1.9124 9.79192C2.69154 7.99031 3.7487 6.42305 5.08389 5.09014C6.41934 3.75723 7.98711 2.70146 9.7872 1.92283C11.587 1.1442 13.5103 0.754883 15.557 0.754883C17.6058 0.754883 19.5311 1.14432 21.3329 1.92321C23.1346 2.70234 24.7018 3.75951 26.0347 5.0947C27.3676 6.43014 28.4234 7.99791 29.202 9.798C29.9807 11.5978 30.37 13.5211 30.37 15.5678C30.37 17.6166 29.9805 19.5419 29.2017 21.3437C28.4225 23.1454 27.3654 24.7126 26.0302 26.0455C24.6947 27.3784 23.127 28.4342 21.3269 29.2128C19.527 29.9915 17.6037 30.3808 15.557 30.3808ZM15.557 27.5321C18.8868 27.5321 21.7133 26.3705 24.0365 24.0473C26.3597 21.7241 27.5213 18.8976 27.5213 15.5678C27.5213 12.2381 26.3597 9.4116 24.0365 7.08837C21.7133 4.76514 18.8868 3.60353 15.557 3.60353C12.2273 3.60353 9.40079 4.76514 7.07757 7.08837C4.75434 9.4116 3.59272 12.2381 3.59272 15.5678C3.59272 18.8976 4.75434 21.7241 7.07757 24.0473C9.40079 26.3705 12.2273 27.5321 15.557 27.5321Z" />
    </svg>
  )
}

export const IconDuplicate = ({
  width = "30px",
  height = "30px",
  color = "#5050EA",
  className = "",
}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 31 31" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M8.96173 17.1942C8.44568 17.1942 8.0039 17.0104 7.63641 16.6429C7.26891 16.2754 7.08517 15.8337 7.08517 15.3176V4.05821C7.08517 3.54215 7.26891 3.10038 7.63641 2.73288C8.0039 2.36539 8.44568 2.18164 8.96173 2.18164H17.4063C17.9223 2.18164 18.3641 2.36539 18.7316 2.73288C19.0991 3.10038 19.2829 3.54215 19.2829 4.05821V15.3176C19.2829 15.8337 19.0991 16.2754 18.7316 16.6429C18.3641 17.0104 17.9223 17.1942 17.4063 17.1942H8.96173ZM8.96173 15.3176H17.4063V4.05821H8.96173V15.3176ZM5.2086 20.9473C4.69254 20.9473 4.25077 20.7636 3.88327 20.3961C3.51578 20.0286 3.33203 19.5868 3.33203 19.0707V6.87306C3.33203 6.60721 3.42195 6.38437 3.60179 6.20453C3.78163 6.02469 4.00447 5.93477 4.27031 5.93477C4.53616 5.93477 4.759 6.02469 4.93884 6.20453C5.11868 6.38437 5.2086 6.60721 5.2086 6.87306V19.0707H14.5914C14.8573 19.0707 15.0801 19.1607 15.26 19.3405C15.4398 19.5203 15.5297 19.7432 15.5297 20.009C15.5297 20.2749 15.4398 20.4977 15.26 20.6776C15.0801 20.8574 14.8573 20.9473 14.5914 20.9473H5.2086Z" />
    </svg>
  )
}

export const IconLink = ({
  width = "30px",
  height = "30px",
  color = "none",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill={color}
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
      />
    </svg>
  )
}

export const IconCircleCheck = ({
  width = "30px",
  height = "30px",
  color = "#ffffff",
  className = "",
}) => {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M6.80125 9.64865L4.72125 7.56865C4.64319 7.4906 4.54757 7.44893 4.43438 7.44365C4.32104 7.43824 4.22007 7.4799 4.13146 7.56865C4.04271 7.65726 3.99833 7.75553 3.99833 7.86344C3.99833 7.97136 4.04271 8.06962 4.13146 8.15824L6.33021 10.357C6.46479 10.4916 6.62181 10.5589 6.80125 10.5589C6.98069 10.5589 7.13778 10.4916 7.2725 10.357L11.8365 5.79303C11.9145 5.71497 11.9562 5.61935 11.9615 5.50615C11.9669 5.39282 11.9252 5.29185 11.8365 5.20324C11.7478 5.11449 11.6496 5.07011 11.5417 5.07011C11.4338 5.07011 11.3355 5.11449 11.2469 5.20324L6.80125 9.64865ZM8.00271 15.0718C6.96563 15.0718 5.99056 14.875 5.0775 14.4814C4.16458 14.0878 3.37042 13.5536 2.695 12.8789C2.01958 12.2041 1.48493 11.4107 1.09104 10.4984C0.697014 9.58636 0.5 8.61171 0.5 7.57449C0.5 6.5374 0.696805 5.56233 1.09042 4.64928C1.48403 3.73636 2.01819 2.94219 2.69292 2.26678C3.36764 1.59136 4.16111 1.05671 5.07333 0.662819C5.98542 0.268791 6.96007 0.0717773 7.99729 0.0717773C9.03438 0.0717773 10.0094 0.268583 10.9225 0.662195C11.8354 1.05581 12.6296 1.58997 13.305 2.26469C13.9804 2.93942 14.5151 3.73289 14.909 4.64511C15.303 5.55719 15.5 6.53185 15.5 7.56907C15.5 8.60615 15.3032 9.58122 14.9096 10.4943C14.516 11.4072 13.9818 12.2014 13.3071 12.8768C12.6324 13.5522 11.8389 14.0868 10.9267 14.4807C10.0146 14.8748 9.03993 15.0718 8.00271 15.0718ZM8 14.2384C9.86111 14.2384 11.4375 13.5926 12.7292 12.3009C14.0208 11.0093 14.6667 9.43289 14.6667 7.57178C14.6667 5.71067 14.0208 4.13428 12.7292 2.84261C11.4375 1.55094 9.86111 0.905111 8 0.905111C6.13889 0.905111 4.5625 1.55094 3.27083 2.84261C1.97917 4.13428 1.33333 5.71067 1.33333 7.57178C1.33333 9.43289 1.97917 11.0093 3.27083 12.3009C4.5625 13.5926 6.13889 14.2384 8 14.2384Z" />
    </svg>
  )
}

export const IconCancelX = ({
  width = "30px",
  height = "30px",
  color = "#ffffff",
  className = "",
}) => {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 21 21" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M6.12544 15.8283L5.53564 15.2386L10.2023 10.5719L5.53564 5.90522L6.12544 5.31543L10.7921 9.9821L15.4588 5.31543L16.0486 5.90522L11.3819 10.5719L16.0486 15.2386L15.4588 15.8283L10.7921 11.1617L6.12544 15.8283Z" />
    </svg>
  )
}

export const AddIconHome = ({
  width = "88px",
  height = "88px",
  color = "#ffffff",
  className = "",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 88 88" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M66 71.5H57.75C56.9708 71.5 56.3175 71.2364 55.7901 70.709C55.2633 70.1816 55 69.5283 55 68.7491C55 67.9694 55.2633 67.3164 55.7901 66.7902C56.3175 66.2634 56.9708 66 57.75 66H66V57.75C66 56.9709 66.2636 56.3176 66.791 55.7902C67.3184 55.2634 67.9717 55 68.7509 55C69.5306 55 70.1836 55.2634 70.7098 55.7902C71.2366 56.3176 71.5 56.9709 71.5 57.75V66H79.75C80.5291 66 81.1821 66.2637 81.7089 66.7911C82.2363 67.3185 82.5 67.9718 82.5 68.751C82.5 69.5307 82.2363 70.1837 81.7089 70.7099C81.1821 71.2367 80.5291 71.5 79.75 71.5H71.5V79.75C71.5 80.5292 71.2363 81.1822 70.7089 81.709C70.1815 82.2364 69.5282 82.5 68.749 82.5C67.9693 82.5 67.3163 82.2364 66.7901 81.709C66.2633 81.1822 66 80.5292 66 79.75V71.5ZM12.9039 72.4167C11.9652 72.4167 11.1781 72.0992 10.5425 71.4643C9.90759 70.8287 9.59012 70.0416 9.59012 69.103V50.4167H8.45437C7.4112 50.4167 6.55228 50.0088 5.87762 49.193C5.20295 48.3777 4.98784 47.4482 5.23228 46.4045L8.89895 29.1995C9.06578 28.4363 9.45567 27.8096 10.0686 27.3195C10.6809 26.8287 11.377 26.5834 12.1568 26.5834H59.3431C60.1229 26.5834 60.8193 26.8287 61.4322 27.3195C62.0445 27.8096 62.4341 28.4363 62.6009 29.1995L66.2676 46.4045C66.5121 47.4482 66.297 48.3777 65.6223 49.193C64.9482 50.0088 64.0893 50.4167 63.0455 50.4167H61.9098V59.1608C61.9098 59.9394 61.6464 60.5923 61.1196 61.1197C60.5922 61.6465 59.9386 61.9099 59.1589 61.9099C58.3797 61.9099 57.7267 61.6465 57.2 61.1197C56.6738 60.5923 56.4107 59.9394 56.4107 59.1608V50.4167H40.7568V69.103C40.7568 70.0416 40.439 70.8287 39.8035 71.4643C39.1685 72.0992 38.3814 72.4167 37.4421 72.4167H12.9039ZM15.0901 66.9167H35.2568V50.4167H15.0901V66.9167ZM12.1989 21.0834C11.4198 21.0834 10.7665 20.8197 10.2391 20.2923C9.71234 19.7649 9.44895 19.1116 9.44895 18.3325C9.44895 17.5527 9.71234 16.8997 10.2391 16.3735C10.7665 15.8468 11.4198 15.5834 12.1989 15.5834H59.3009C60.0801 15.5834 60.7334 15.8471 61.2608 16.3745C61.7876 16.9018 62.0509 17.5551 62.0509 18.3343C62.0509 19.1141 61.7876 19.767 61.2608 20.2932C60.7334 20.82 60.0801 21.0834 59.3009 21.0834H12.1989ZM11.1127 44.9167H60.3872L57.5877 32.0834H13.9122L11.1127 44.9167Z" fill={color} />
    </svg>

  )
}

export const IconCredit1 = ({
  width = "10px",
  height = "10px",
  color = "#ffffff",
  className = "",
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      class="lucide lucide-coins h-3 w-3"
      data-lov-id="src/components/MarketingAnglePage.tsx:250:22"
      data-lov-name="Coins"
      data-component-path="src/components/MarketingAnglePage.tsx"
      data-component-line="250"
      data-component-file="MarketingAnglePage.tsx"
      data-component-name="Coins"
      data-component-content="%7B%22className%22%3A%22h-3%20w-3%22%7D">
      <circle cx="8" cy="8" r="6"></circle>
      <path d="M18.09 10.37A6 6 0 1 1 10.34 18">
      </path><path d="M7 6h1v4"></path><path d="m16.71 13.88.7.71-2.82 2.82"></path>
    </svg>
  )
}

export const IconTrash = ({
  width = "24",
  height = "24",
  color = "#D3372F",
  className = "",
}) => {
  return (
    <svg width={width} height={height} className={className} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.6155 20.0002C7.168 20.0002 6.78683 19.8429 6.472 19.5282C6.15733 19.2134 6 18.8322 6 18.3847V6.00021H5.5C5.35767 6.00021 5.23875 5.95246 5.14325 5.85696C5.04775 5.76146 5 5.64254 5 5.50021C5 5.35787 5.04775 5.23896 5.14325 5.14346C5.23875 5.04796 5.35767 5.00021 5.5 5.00021H9C9 4.79387 9.07658 4.61404 9.22975 4.46071C9.38292 4.30754 9.56275 4.23096 9.76925 4.23096H14.2308C14.4372 4.23096 14.6171 4.30754 14.7703 4.46071C14.9234 4.61404 15 4.79387 15 5.00021H18.5C18.6423 5.00021 18.7613 5.04796 18.8568 5.14346C18.9523 5.23896 19 5.35787 19 5.50021C19 5.64254 18.9523 5.76146 18.8568 5.85696C18.7613 5.95246 18.6423 6.00021 18.5 6.00021H18V18.3847C18 18.8322 17.8427 19.2134 17.528 19.5282C17.2132 19.8429 16.832 20.0002 16.3845 20.0002H7.6155ZM17 6.00021H7V18.3847C7 18.5642 7.05767 18.7117 7.173 18.8272C7.2885 18.9425 7.436 19.0002 7.6155 19.0002H16.3845C16.564 19.0002 16.7115 18.9425 16.827 18.8272C16.9423 18.7117 17 18.5642 17 18.3847V6.00021ZM12 13.208L14.2462 15.454C14.3397 15.5476 14.4545 15.5976 14.5905 15.604C14.7263 15.6105 14.8474 15.5605 14.9538 15.454C15.0603 15.3476 15.1135 15.2297 15.1135 15.1002C15.1135 14.9707 15.0603 14.8528 14.9538 14.7465L12.7077 12.5002L14.9538 10.254C15.0474 10.1605 15.0974 10.0457 15.1038 9.90971C15.1103 9.77387 15.0603 9.65279 14.9538 9.54646C14.8474 9.43996 14.7295 9.38671 14.6 9.38671C14.4705 9.38671 14.3526 9.43996 14.2462 9.54646L12 11.7925L9.75375 9.54646C9.66025 9.45279 9.5455 9.40279 9.4095 9.39646C9.27367 9.38996 9.15258 9.43996 9.04625 9.54646C8.93975 9.65279 8.8865 9.77071 8.8865 9.90021C8.8865 10.0297 8.93975 10.1476 9.04625 10.254L11.2923 12.5002L9.04625 14.7465C8.95258 14.84 8.90258 14.9547 8.89625 15.0907C8.88975 15.2265 8.93975 15.3476 9.04625 15.454C9.15258 15.5605 9.2705 15.6137 9.4 15.6137C9.5295 15.6137 9.64742 15.5605 9.75375 15.454L12 13.208Z" fill={color} />
    </svg>
  )
}

// banderas de los paises

export const IconHonduras = ({
  width = "24",
  height = "24",
  color = "#fafafa",
  className = "",
}) => {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 25.98 25.98" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path style={{ fill: "#43ade2" }} d="M12.99,25.98c5.66,0,10.46-3.62,12.25-8.66H.74c1.78,5.04,6.59,8.66,12.25,8.66Z" />
          <path style={{ fill: "#43ade2" }} d="M12.99,0C7.33,0,2.53,3.62.74,8.66h24.5C23.45,3.62,18.65,0,12.99,0Z" />
          <path style={{ fill: "#fafafa" }} d="M25.24,17.32c.48-1.35.74-2.81.74-4.33s-.26-2.98-.74-4.33H.74c-.48,1.35-.74,2.81-.74,4.33s.26,2.98.74,4.33h24.5Z" />
          <polygon style={{ fill: "#43ade2" }} points="12.99 13.68 13.79 14.29 13.49 13.3 14.29 12.68 13.3 12.68 12.99 11.69 12.68 12.68 11.69 12.68 12.49 13.3 12.19 14.29 12.99 13.68" />
          <polygon style={{ fill: "#43ade2" }} points="8.66 11.51 9.46 12.12 9.16 11.13 9.96 10.52 8.97 10.51 8.66 9.53 8.35 10.51 7.36 10.52 8.16 11.13 7.86 12.12 8.66 11.51" />
          <polygon style={{ fill: "#43ade2" }} points="17.32 11.51 18.12 12.12 17.82 11.13 18.62 10.52 17.63 10.51 17.32 9.53 17.01 10.51 16.02 10.52 16.82 11.13 16.52 12.12 17.32 11.51" />
          <polygon style={{ fill: "#43ade2" }} points="8.66 15.84 9.46 16.45 9.16 15.46 9.96 14.85 8.97 14.84 8.66 13.86 8.35 14.84 7.36 14.85 8.16 15.46 7.86 16.45 8.66 15.84" />
          <polygon style={{ fill: "#43ade2" }} points="17.32 15.84 18.12 16.45 17.82 15.46 18.62 14.85 17.63 14.84 17.32 13.86 17.01 14.84 16.02 14.85 16.82 15.46 16.52 16.45 17.32 15.84" />
        </g>
      </g>
    </svg>
  )
}

export const IconArgentina = ({
  width = "24",
  height = "24",
  color = "#fafafa",
  className = "",
}) => {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 25.98 25.98" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path style={{ fill: "#fafafa" }} d="M0,12.99c0,2.55.74,4.92,2,6.93h21.97c1.27-2.01,2-4.38,2-6.93s-.74-4.92-2-6.93H2C.74,8.07,0,10.44,0,12.99Z" />
          <path style={{ fill: "#b4d7ed" }} d="M23.98,6.06C21.67,2.42,17.62,0,12.99,0S4.31,2.42,2,6.06h21.97Z" />
          <path style={{ fill: "#b4d7ed" }} d="M2,19.92c2.3,3.64,6.36,6.06,10.99,6.06s8.68-2.42,10.99-6.06H2Z" />
          <path style={{ fill: "#f7b412" }} d="M18.94,12.92l-3.54-.13s0-.03,0-.04c.58-.11.99-.43,1.59-.38.73.07,1.15-.34,1.44-.43.29-.09.46.1.5.02.04-.08-.19-.27-.59-.21-.41.06-.53.37-1.42.3-.76-.06-1.03.24-1.59.27,0-.02-.01-.04-.02-.05l3.21-1.47s.1-.04.07-.11c-.03-.07-.13-.03-.13-.03l-3.32,1.23s-.01-.02-.02-.04c.49-.32.75-.78,1.32-.96.7-.22.93-.75,1.16-.95.23-.2.46-.08.47-.17,0-.09-.27-.18-.63.03-.35.21-.35.54-1.2.82-.73.23-.86.62-1.37.86-.01-.01-.02-.03-.04-.04l2.41-2.59s.08-.08.03-.13c-.05-.05-.13.03-.13.03l-2.59,2.41s-.02-.02-.03-.03c.33-.48.39-1.01.86-1.39.57-.47.57-1.05.71-1.32.14-.27.39-.25.36-.34s-.32-.06-.57.27c-.25.33-.11.63-.8,1.22-.58.5-.55.9-.93,1.32-.02,0-.03-.02-.05-.03l1.23-3.32s.04-.1-.03-.13c-.07-.03-.11.07-.11.07l-1.48,3.21s-.03,0-.04-.01c.12-.57-.02-1.08.26-1.61.34-.65.13-1.19.15-1.49s.27-.38.21-.45c-.06-.07-.32.07-.42.47-.1.4.14.63-.27,1.43-.35.68-.17,1.04-.36,1.58-.02,0-.04,0-.06,0l-.13-3.54s0-.11-.07-.11-.07.11-.07.11l-.13,3.54s-.03,0-.04,0c-.11-.58-.43-.99-.38-1.59.07-.73-.34-1.15-.43-1.44s.1-.46.02-.5c-.08-.04-.27.19-.21.59.06.41.37.53.3,1.42-.06.76.24,1.03.27,1.59-.02,0-.04.01-.05.02l-1.48-3.21s-.04-.1-.11-.07c-.07.03-.03.13-.03.13l1.23,3.32s-.02.01-.04.02c-.32-.49-.78-.75-.96-1.32-.22-.7-.75-.93-.95-1.16-.2-.23-.08-.46-.17-.47-.09,0-.18.27.03.63.21.35.54.35.82,1.2.23.73.62.86.86,1.37-.01.01-.03.02-.04.04l-2.59-2.41s-.08-.08-.13-.03c-.05.05.03.13.03.13l2.41,2.59s-.02.02-.03.03c-.48-.33-1.01-.39-1.39-.86-.47-.57-1.05-.58-1.32-.71-.27-.14-.25-.39-.34-.36-.09.03-.06.32.27.57.33.24.63.11,1.22.8.5.58.9.55,1.32.93,0,.02-.02.03-.03.05l-3.32-1.23s-.1-.04-.13.03c-.03.07.07.11.07.11l3.21,1.47s0,.03-.01.04c-.58-.12-1.08.02-1.61-.26-.65-.34-1.19-.13-1.49-.15-.3-.02-.38-.27-.45-.21-.07.06.07.32.47.42.4.1.63-.14,1.43.27.68.35,1.04.17,1.58.36,0,.02,0,.04,0,.06l-3.54.13s-.11,0-.11.07.11.07.11.07l3.54.13s0,.03,0,.04c-.58.11-.99.43-1.59.38-.73-.07-1.15.34-1.44.43-.29.09-.46-.1-.5-.02-.04.08.19.27.59.21s.53-.37,1.42-.3c.76.06,1.03-.24,1.59-.27,0,.02,0,.04.02.05l-3.21,1.47s-.1.04-.07.11c.03.07.13.03.13.03l3.32-1.23s.01.02.02.04c-.49.32-.75.78-1.32.96-.7.22-.93.75-1.16.95-.23.2-.46.08-.47.17s.27.18.63-.03c.35-.21.35-.54,1.2-.82.73-.23.86-.62,1.37-.86.01.01.02.03.04.04l-2.41,2.59s-.08.08-.03.13c.05.05.13-.03.13-.03l2.59-2.41s.02.02.03.03c-.33.48-.39,1.01-.86,1.39-.57.47-.57,1.05-.71,1.32-.14.27-.39.25-.36.34.03.09.32.06.57-.27s.11-.63.8-1.22c.58-.5.55-.9.93-1.32.02,0,.03.02.05.03l-1.23,3.32s-.04.1.03.13c.07.03.11-.07.11-.07l1.48-3.21s.03,0,.04.01c-.12.57.02,1.08-.26,1.61-.34.65-.13,1.19-.15,1.49-.02.3-.27.38-.21.45.06.07.32-.07.42-.47.1-.4-.14-.63.27-1.43.35-.68.17-1.04.36-1.58.02,0,.04,0,.06,0l.13,3.53s0,.11.07.11.07-.11.07-.11l.13-3.53s.03,0,.04,0c.11.58.43.99.38,1.59-.07.73.34,1.15.43,1.44.09.29-.1.46-.02.5.08.04.27-.19.21-.59-.06-.41-.37-.53-.3-1.42.06-.76-.24-1.03-.27-1.59.02,0,.04,0,.05-.02l1.47,3.21s.04.1.11.08c.07-.03.03-.13.03-.13l-1.23-3.32s.02-.01.04-.02c.32.49.78.75.96,1.32.22.7.75.93.95,1.16.2.23.08.46.17.47s.18-.27-.03-.63c-.21-.35-.54-.35-.82-1.2-.23-.73-.62-.86-.86-1.37.01-.01.03-.02.04-.04l2.59,2.41s.08.08.13.03c.05-.05-.03-.13-.03-.13l-2.41-2.59s.02-.02.03-.03c.48.33,1.01.39,1.39.86.47.57,1.05.58,1.32.71.27.14.25.39.34.36.09-.03.06-.32-.27-.57-.33-.24-.63-.11-1.22-.8-.49-.58-.9-.55-1.32-.93,0-.02.02-.03.03-.05l3.32,1.23s.1.04.13-.03c.03-.07-.07-.11-.07-.11l-3.21-1.48s0-.03.01-.04c.58.12,1.08-.02,1.61.26.65.34,1.19.13,1.49.15.3.02.38.27.45.21.07-.06-.07-.32-.47-.42-.4-.1-.63.14-1.43-.27-.68-.35-1.04-.17-1.58-.36,0-.02,0-.04,0-.06l3.54-.13s.11,0,.11-.07-.11-.07-.11-.07Z" />
          <path style={{ fill: "#853512" }} d="M13.7,12.53s-.06.08-.06.13c0,.06.04.12.09.15-.09-.01-.18-.05-.26-.11.06-.09.14-.14.23-.17ZM14.15,12.65c-.07.08-.16.12-.25.14.05-.03.08-.08.08-.14,0-.06-.03-.11-.07-.14.12.02.22.08.24.14ZM14.28,12.67c-.12-.13-.3-.2-.46-.2s-.32.07-.42.22c.19.17.6.19.88-.02Z" />
          <path style={{ fill: "#853512" }} d="M13.85,12.36h0c-.24,0-.3.06-.41.15-.11.09-.17.07-.19.09-.02.02,0,.07.04.06.04-.02.11-.06.22-.15.11-.09.22-.09.34-.09.34,0,.52.28.56.26.04-.02-.19-.32-.56-.32Z" />
          <polygon style={{ fill: "#853512" }} points="14.52 12.47 14.52 12.47 14.52 12.47 14.52 12.47" />
          <path style={{ fill: "#853512" }} d="M13.14,12.28c-.03.07-.05.14-.06.21-.05.28,0,.57.15.85.02-.02.06-.04.07-.04-.17-.24-.23-.46-.19-.68.02-.11.07-.21.14-.31.3-.28.84-.22,1.27.15-.41-.56-.97-.52-1.38-.19Z" />
          <path style={{ fill: "#853512" }} d="M13.55,12.84c-.15-.07-.19-.11-.22-.11s-.04.04.15.15c.19.11.5.13.82-.11-.37.15-.6.15-.75.07Z" />
          <path style={{ fill: "#853512" }} d="M13.34,13.54c-.06,0-.11-.05-.11-.11-.02.04-.09.14-.23.15-.14,0-.21-.11-.23-.15,0,.06-.05.11-.11.11-.06,0-.11-.05-.11-.11,0-.05.03-.09.07-.11-.08.01-.14.09-.14.17,0,.09.08.17.17.17.05,0,.11-.03.14-.07.06.05.15.05.2.05h.02s.14,0,.2-.05c.03.05.08.07.14.07.09,0,.17-.07.17-.17,0-.08-.06-.15-.14-.17.04.02.07.06.07.11,0,.06-.05.11-.11.11Z" />
          <path style={{ fill: "#853512" }} d="M12.99,13.93h0c.07,0,.19-.09.32-.02.13.07.21.15.3.19-.17-.11-.24-.28-.43-.28-.04,0-.11.02-.19.06h0c-.07-.04-.15-.06-.19-.06-.19,0-.26.17-.43.28.09-.04.17-.11.3-.19s.24.02.32.02Z" />
          <path style={{ fill: "#853512" }} d="M12.99,14.31h0c-.31,0-.22-.21-.54-.21,0,0,0,0,0,0,.33-.07.4.04.55.04h0c.15,0,.22-.11.54-.04-.32,0-.23.21-.54.21ZM12.99,14.06h0c-.07,0-.13-.03-.25-.02-.07,0-.17.02-.3.06-.02,0-.04,0-.06,0,.39.04.2.26.61.26h0c.41,0,.22-.22.62-.26-.03,0-.05,0-.07,0-.36-.11-.44-.03-.55-.03Z" />
          <path style={{ fill: "#853512" }} d="M12.99,14.37c-.19,0-.34.15-.34.34.04-.16.18-.27.34-.27s.3.11.34.27c0-.19-.15-.34-.34-.34Z" />
          <polygon style={{ fill: "#853512" }} points="11.48 12.47 11.48 12.47 11.48 12.47 11.48 12.47" />
          <path style={{ fill: "#853512" }} d="M12.75,12.32c.07.1.12.2.14.31.04.21-.03.44-.2.68.02,0,.06.02.07.04.15-.28.2-.57.15-.85-.01-.07-.03-.14-.06-.21-.41-.34-.97-.37-1.38.19.43-.37.97-.43,1.27-.15Z" />
          <path style={{ fill: "#853512" }} d="M12.49,12.51c.11.09.19.13.22.15.04.02.06-.04.04-.06-.02-.02-.07,0-.19-.09-.11-.09-.17-.15-.41-.15-.37,0-.6.3-.56.32s.22-.26.56-.26c.11,0,.22,0,.34.09Z" />
          <path style={{ fill: "#853512" }} d="M12.47,12.65c-.06.06-.13.11-.2.13.04-.03.06-.08.06-.13s-.02-.1-.06-.13c.11.02.19.08.2.13ZM11.8,12.69c.07-.11.16-.16.27-.18-.04.03-.07.08-.07.14,0,.07.04.12.1.15-.11,0-.21-.05-.29-.11ZM11.72,12.69c.1.09.26.14.44.13,0,0,0,0,0,0,0,0,0,0,0,0,.15,0,.31-.05.43-.15-.12-.13-.3-.2-.46-.2-.16,0-.32.07-.42.22Z" />
          <path style={{ fill: "#853512" }} d="M12.68,12.73s-.07.04-.22.11-.37.07-.75-.07c.32.24.63.22.82.11.19-.11.19-.15.15-.15Z" />
        </g>
      </g>
    </svg>
  )
}

export const IconColombia = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path
            style={{ fill: "#2a5f9f" }}
            d="M25.98,12.99H0c0,2.37.64,4.58,1.74,6.5h22.5c1.11-1.91,1.74-4.13,1.74-6.5Z"
          />
          <path
            style={{ fill: "#ffe72d" }}
            d="M12.99,0C5.82,0,0,5.82,0,12.99h25.98C25.98,5.82,20.16,0,12.99,0Z"
          />
          <path
            style={{ fill: "#e94d5c" }}
            d="M12.99,25.98c4.81,0,9-2.61,11.25-6.5H1.74c2.25,3.88,6.44,6.5,11.25,6.5Z"
          />
        </g>
      </g>
    </svg>
  )
}

export const IconSpain = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path style={{ fill: "#ffce35" }} d="M0,12.99c0,2.55.74,4.92,2,6.93h21.97c1.27-2.01,2-4.38,2-6.93s-.74-4.92-2-6.93H2C.74,8.07,0,10.44,0,12.99Z" />
          <path style={{ fill: "#e94d5c" }} d="M23.98,6.06C21.67,2.42,17.62,0,12.99,0S4.31,2.42,2,6.06h21.97Z" />
          <path style={{ fill: "#e94d5c" }} d="M2,19.92c2.3,3.64,6.36,6.06,10.99,6.06s8.68-2.42,10.99-6.06H2Z" />

          <rect style={{ fill: "#c8b100" }} x="3.14" y="11.57" width="1.39" height=".76" />
          <rect style={{ fill: "#c8b100" }} x="3.12" y="17.27" width="1.42" height=".72" />
          <rect style={{ fill: "#fff" }} x="3.32" y="12.32" width="1.01" height="4.95" />

          <rect style={{ fill: "#c8b100" }} x="12.41" y="11.57" width="1.39" height=".76" />
          <rect style={{ fill: "#c8b100" }} x="12.39" y="17.27" width="1.42" height=".72" />
          <rect style={{ fill: "#fff" }} x="12.6" y="12.32" width="1.01" height="4.95" />

          <path style={{ fill: "#e94d5c" }} d="M8.42,8.78c.83,0,2.5.19,3.11.77-.64,1.56-1.7.92-3.1.92-1.41,0-2.46.64-3.11-.92.61-.57,2.27-.77,3.09-.77Z" />
          <path style={{ fill: "#c8b100" }} d="M10.58,10.51c-.54-.3-1.29-.37-2.13-.37-.83,0-1.58.07-2.12.37l.19.73c.49.15,1.17.24,1.93.24.76,0,1.44-.09,1.93-.24l.2-.73Z" />

          <path style={{ fill: "#235ca8" }} d="M8.17,7.82c0-.14.12-.26.28-.26s.28.12.28.26-.12.26-.28.26-.28-.12-.28-.26" />

          <rect style={{ fill: "#fff" }} x="8.46" y="11.5" width="3.13" height="3.46" />
          <rect style={{ fill: "#e94d5c" }} x="5.35" y="11.5" width="3.12" height="3.46" />

          <path style={{ fill: "#e94d5c" }} d="M7.46,14.95c0-.63.45-1.14,1.01-1.14s1.01.51,1.01,1.14-.45,1.14-1.01,1.14-1.01-.51-1.01-1.14" />
          <path style={{ fill: "#235ca8" }} d="M7.76,14.95c0-.46.32-.83.71-.83s.71.37.71.83-.32.83-.71.83-.71-.37-.71-.83" />
        </g>
      </g>
    </svg>
  )
}

export const IconEcuador = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path style={{ fill: "#2a5f9f" }} d="M25.98,12.99H0c0,2.37.64,4.58,1.74,6.5h22.5c1.11-1.91,1.74-4.13,1.74-6.5Z" />
          <path style={{ fill: "#ffe72d" }} d="M12.99,0C5.82,0,0,5.82,0,12.99h25.98C25.98,5.82,20.16,0,12.99,0Z" />
          <path style={{ fill: "#e94d5c" }} d="M12.99,25.98c4.81,0,9-2.61,11.25-6.5H1.74c2.25,3.88,6.44,6.5,11.25,6.5Z" />

          <path style={{ fill: "#0b4f9e" }} d="M10.12,11.95l.36.36.17-.41.03-.25c-.03-.73-.01-1.44-.01-1.44l.11.09-.64-.65s0,1.53-.01,2.3Z" />
          <path style={{ fill: "#e52528" }} d="M10.68,11.64l.36-1.08-.37-.36s-.01.71.01,1.44Z" />
          <path style={{ fill: "#ffdd06" }} d="M10.14,9.65l.24.24c-.43-.44-.93-.96-1.19-1.22-.05-.05-.06,1.05-.05,2.28l.99,1c0-.77.01-2.3.01-2.3Z" />

          <path style={{ fill: "#ffdd06" }} d="M10.45,16.23c-.8-.51-.93-2.09-.92-2.3.01-.21.02-2.72.02-2.72l-.64-.65c-.08-.08-.02,3.29-.02,4.78,0,.7.43,3.18,2.94,1.93,0,0,1.26-.46,1.62-1.02-.09,0-.17,0-.25-.02-.04.02-.08.04-.12.06-1.45,1-2.31.26-2.31.26Z" />
          <path style={{ fill: "#0b4f9e" }} d="M9.53,13.93c-.01.21.12,1.79.92,2.3,0,0,.86.73,2.31-.26-.44.19-.8.22-1.03.15-.7-.21-1.44-1.04-1.56-1.88-.12-.84-.09-2.48-.09-2.48l-.64-.65s0,2.51-.02,2.72Z" />
          <path style={{ fill: "#e52528" }} d="M10.56,12.84c0-.08-.01-.35-.01-.64l-.46-.47c0,.23-.02,1.68.09,2.45.12.84.84,1.66,1.54,1.88.23.07.61.03,1.05-.15.03-.02.06-.04.09-.06-1.27-.18-2.14-1.39-2.3-3.06Z" />

          <path style={{ fill: "#ffdd06" }} d="M15.53,16.28c.8-.51.93-2.09.92-2.3-.01-.21-.02-2.72-.02-2.72l.64-.65c.08-.08.02,3.29.02,4.78,0,.7-.43,3.18-2.94,1.93,0,0-1.26-.46-1.62-1.02.09,0,.17,0,.25-.02.04.02.08.04.12.06,1.45,1,2.31.26,2.31.26Z" />
          <path style={{ fill: "#0b4f9e" }} d="M16.45,13.98c.01.21-.12,1.79-.92,2.3,0,0-.86.73-2.31-.26.44.18.8.22,1.03.15.7-.21,1.44-1.04,1.56-1.88.12-.84.09-2.48.09-2.48l.64-.65s0,2.51.02,2.72Z" />
          <path style={{ fill: "#e52528" }} d="M15.42,12.9c0-.08.01-.35.01-.64l.46-.47c0,.23.02,1.68-.09,2.45-.12.84-.84,1.66-1.54,1.88-.23.07-.61.03-1.05-.15-.03-.02-.06-.04-.09-.06,1.27-.18,2.14-1.39,2.3-3.06Z" />

          <path style={{ fill: "#92d2e1" }} d="M10.51,12.57c0,1.76,1.11,3.19,2.48,3.19s2.48-1.43,2.48-3.19-1.11-3.19-2.48-3.19-2.48,1.43-2.48,3.19" />
          <path style={{ fill: "#79b93c" }} d="M10.5,12.68c0,1.76,1.11,3.19,2.48,3.19s2.48-1.43,2.48-3.19h-4.96" />
          <path style={{ fill: "#557277" }} d="M10.63,12.79l4.66.07s.02-.33.02-.36.08-.09-.06-.11c-.52-.05-.32-.08-.63-.1-.07-.02-2.07-.47-2.25-.5-.18-.02-1.72.21-1.72.21l-.03.79Z" />

          <path style={{ fill: "#fff" }} d="M10.58,11.95l.75.32s.95-.18,1.03-.14c.08.04.93.16.97.16s1.24-.02,1.24-.02c-.07-.07-1.05-.33-1.11-.38-.06-.05-.76-.31-.83-.37-.07-.07-.61-.39-.67-.39-.14,0-1.32.81-1.32.81" />

          <path style={{ fill: "#b1babf" }} d="M13.41,15.71s-.24.04-.45.04-.41-.05-.41-.05c-1.04-.29-1.87-1.56-1.87-3.08,0-.54.12-1.07.29-1.51.24-.62.65-1.1,1.12-1.39,0,0,.47-.29.88-.3.56,0,.98.32.98.32.79.5,1.33,1.6,1.33,2.87,0,1.55-.81,2.83-1.87,3.1" />

          <path style={{ fill: "#0b4f9e" }} d="M11.5,12.63l.75,1-.39.23s.09.28.3.55c.22.28.72.81,1.23.86.52.05.88.03,1.16-.13.28-.16.66-.41.91-.81.25-.41.26-.47.26-.47s-1.63-.33-1.68-.37c-.05-.04-1.6-1.26-1.64-1.29-.05-.03.33-.51.33-.51l-.5.5Z" />

          <rect style={{ fill: "#e52528" }} x="12.58" y="16.37" width=".82" height="2.13" />
          <rect style={{ fill: "#0b4f9e" }} x="11.94" y="16.56" width=".82" height="2.13" />
          <rect style={{ fill: "#0b4f9e" }} x="13.23" y="16.56" width=".82" height="2.13" />
          <rect style={{ fill: "#ffdd06" }} x="11.79" y="16.56" width=".52" height="2.68" />
          <rect style={{ fill: "#ffdd06" }} x="13.67" y="16.56" width=".52" height="2.68" />
          <rect style={{ fill: "#fff" }} x="11.04" y="15.63" width="3.91" height="1.03" />

          <path style={{ fill: "#594640" }} d="M15.42,7.14c-.76,0-1.62.87-2.43.87s-1.67-.87-2.43-.87-3.64.87-3.64.87c4.04,0,6.06,2.17,6.06,2.17s2.02-2.17,6.06-2.17c0,0-2.88-.87-3.64-.87Z" />
          <circle style={{ fill: "#fafafa" }} cx="12.99" cy="7.65" r=".5" />
        </g>
      </g>
    </svg>
  )
}

export const IconParaguay = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path style={{ fill: "#428bc1" }} d="M12.99,25.98c5.66,0,10.46-3.62,12.25-8.66H.74c1.78,5.04,6.59,8.66,12.25,8.66Z" />
          <path style={{ fill: "#e94d5c" }} d="M12.99,0C7.33,0,2.53,3.62.74,8.66h24.5C23.45,3.62,18.65,0,12.99,0Z" />
          <path style={{ fill: "#fafafa" }} d="M25.24,17.32c.48-1.35.74-2.81.74-4.33s-.26-2.98-.74-4.33H.74c-.48,1.35-.74,2.81-.74,4.33s.26,2.98.74,4.33h24.5Z" />

          <path style={{ fill: "#3e4347" }} d="M12.99,9.22c-2.08,0-3.77,1.69-3.77,3.77s1.69,3.77,3.77,3.77,3.77-1.69,3.77-3.77-1.69-3.77-3.77-3.77ZM12.99,16.89c-2.15,0-3.9-1.75-3.9-3.9s1.75-3.9,3.9-3.9,3.9,1.75,3.9,3.9-1.75,3.9-3.9,3.9Z" />
          <path style={{ fill: "#e94d5c" }} d="M12.99,15.46c-1.36,0-2.47-1.1-2.47-2.47s1.1-2.47,2.47-2.47,2.47,1.1,2.47,2.47-1.1,2.47-2.47,2.47ZM12.99,9.7c-1.81,0-3.29,1.47-3.29,3.29s1.47,3.29,3.29,3.29,3.29-1.47,3.29-3.29-1.47-3.29-3.29-3.29Z" />
          <path style={{ fill: "#ffce35" }} d="M10.39,12.99c0-1.43,1.16-2.6,2.6-2.6s2.6,1.16,2.6,2.6h.57c0-1.75-1.42-3.17-3.17-3.17s-3.17,1.42-3.17,3.17h.57Z" />
          <path style={{ fill: "#428bc1" }} d="M14.23,12.84c0,.68-.55,1.24-1.24,1.24s-1.24-.55-1.24-1.24.55-1.24,1.24-1.24,1.24.55,1.24,1.24Z" />
          <polygon
            style={{ fill: "#ffce35" }}
            points="13.66 13.69 12.99 13.23 12.32 13.69 12.57 12.95 11.98 12.48 12.74 12.48 12.99 11.74 13.24 12.48 14 12.48 13.41 12.95 13.66 13.69"
          />

          {/* Ramas izquierda */}
          <path style={{ fill: "#689635" }} d="M11.87,11.9c-.1-.15-.13-.43-.13-.43-.1.15-.13.43-.13.43.12-.03.28.04.28.04s.16-.07.19-.19Z" />
          <path style={{ fill: "#85be4f" }} d="M11.65,12.26c.06-.17.01-.44.01-.44-.06.17-.01.44-.01.44.11-.06.28-.03.28-.03s.03-.17-.14-.23Z" />
          <path style={{ fill: "#689635" }} d="M11.52,12.66c0-.18-.1-.43-.1-.43 0,.18.1.43.1.43.09-.09.26-.1.26-.1s.02-.17-.26.1Z" />
          <path style={{ fill: "#85be4f" }} d="M11.51,13.07c-.04-.17-.21-.39-.21-.39.04.17.21.39.21.39.06-.11.23-.16.23-.16Z" />
          <path style={{ fill: "#689635" }} d="M11.61,13.48c-.08-.16-.31-.32-.31-.32.08.16.31.32.31.32.03-.12.17-.22.17-.22Z" />
          <path style={{ fill: "#85be4f" }} d="M11.8,13.85c-.12-.13-.38-.23-.38-.23.12.13.38.23.38.23.01-.12.11-.25.11-.25Z" />
          <path style={{ fill: "#689635" }} d="M12.09,14.15c-.15-.1-.43-.13-.43-.13.15.1.43.13.43.13-.03-.12.04-.27.04-.27Z" />
          <path style={{ fill: "#85be4f" }} d="M12.45,14.37c-.17-.05-.45-.01-.45-.01.17.05.45.01.45.01-.06-.11-.03-.28-.03-.28Z" />

          {/* Ramas derecha */}
          <path style={{ fill: "#689635" }} d="M14.11,11.9c.1-.15.13-.43.13-.43.1.15.13.43.13.43-.12-.03-.28.04-.28.04s-.16-.07-.19-.19Z" />
          <path style={{ fill: "#85be4f" }} d="M14.33,12.26c-.06-.17-.01-.44-.01-.44.06.17.01.44.01.44-.11-.06-.28-.03-.28-.03s-.03-.17.14-.23Z" />
          <path style={{ fill: "#689635" }} d="M14.46,12.66c0-.18.1-.43.1-.43 0,.18-.1.43-.1.43-.09-.09-.26-.1-.26-.1s-.02-.17.26.1Z" />
          <path style={{ fill: "#85be4f" }} d="M14.47,13.07c.04-.17.21-.39.21-.39-.04.17-.21.39-.21.39-.06-.11-.23-.16-.23-.16Z" />
          <path style={{ fill: "#689635" }} d="M14.37,13.48c.08-.16.31-.32.31-.32-.08.16-.31.32-.31.32-.03-.12-.17-.22-.17-.22Z" />
          <path style={{ fill: "#85be4f" }} d="M14.18,13.85c.12-.13.38-.23.38-.23-.12.13-.38.23-.38.23-.01-.12-.11-.25-.11-.25Z" />
          <path style={{ fill: "#689635" }} d="M13.89,14.15c.15-.1.43-.13.43-.13-.15.1-.43.13-.43.13.03-.12-.04-.27-.04-.27Z" />
          <path style={{ fill: "#85be4f" }} d="M13.53,14.37c.17-.05.45-.01.45-.01-.17.05-.45.01-.45.01.06-.11.03-.28.03-.28Z" />
        </g>
      </g>
    </svg>
  )
}

export const IconUSA = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path style={{ fill: "#e94d5c" }} d="M19.91,2c-2-1.26-4.37-2-6.92-2v2h6.92Z" />
          <path style={{ fill: "#fff" }} d="M12.99,3.99h9.36c-.73-.76-1.55-1.43-2.45-2h-6.92v2Z" />
          <path style={{ fill: "#e94d5c" }} d="M12.99,5.99h10.94c-.46-.72-.99-1.38-1.57-2h-9.36v2Z" />
          <path style={{ fill: "#fff" }} d="M12.99,7.98h11.99c-.29-.7-.65-1.37-1.05-2h-10.94v2Z" />
          <path style={{ fill: "#e94d5c" }} d="M12.99,9.98h12.64c-.16-.69-.38-1.36-.65-2h-11.99v2Z" />
          <path style={{ fill: "#fff" }} d="M12.99,11.98h12.95c-.05-.68-.16-1.35-.31-2h-12.64v2Z" />
          <path style={{ fill: "#e94d5c" }} d="M25.94,11.98h-12.95v1.01H0c0,.33.02.66.04.98h25.9c.02-.33.04-.65.04-.98s-.02-.68-.04-1.01Z" />
          <path style={{ fill: "#fff" }} d="M.35,15.97h25.29c.15-.65.26-1.31.31-2H.04c.05.68.15,1.35.31,2Z" />
          <path style={{ fill: "#e94d5c" }} d="M.99,17.96h24c.27-.64.48-1.31.64-2H.35c.16.69.38,1.35.64,2Z" />
          <path style={{ fill: "#fff" }} d="M2.03,19.96h21.92c.4-.63.75-1.3,1.04-2H.99c.29.7.64,1.36,1.04,2Z" />
          <path style={{ fill: "#e94d5c" }} d="M3.6,21.96h18.79c.58-.61,1.11-1.28,1.57-2H2.03c.46.72.98,1.38,1.56,2Z" />
          <path style={{ fill: "#fff" }} d="M6.03,23.95h13.93c.89-.57,1.7-1.24,2.43-2H3.6c.72.76,1.54,1.43,2.43,2Z" />
          <path style={{ fill: "#e94d5c" }} d="M12.99,25.98c2.56,0,4.95-.75,6.96-2.03H6.03c2.01,1.28,4.4,2.03,6.96,2.03Z" />

          <path
            style={{ fill: "#428bc1" }}
            d="M6.07,2c-.9.57-1.72,1.24-2.45,2-.59.61-1.11,1.28-1.57,2-.4.63-.76,1.3-1.05,2-.27.64-.48,1.31-.65,2-.15.65-.26,1.31-.31,2-.03.33-.04.67-.04,1.01h12.99V0c-2.54,0-4.91.73-6.92,2Z"
          />

          {/* Stars */}
          <polygon style={{ fill: "#fff" }} points="9.96 .43 10.16 1.07 10.83 1.07 10.29 1.5 10.49 2.15 9.96 1.76 9.42 2.17 9.63 1.5 9.09 1.07 9.75 1.07 9.96 .43" />
          <polygon style={{ fill: "#fff" }} points="11.69 3.03 11.9 3.67 12.56 3.67 12.02 4.1 12.23 4.75 11.69 4.36 11.16 4.76 11.36 4.1 10.83 3.67 11.49 3.67 11.69 3.03" />
          <polygon style={{ fill: "#fff" }} points="8.23 3.03 8.43 3.67 9.09 3.67 8.56 4.1 8.76 4.75 8.23 4.36 7.69 4.76 7.9 4.1 7.36 3.67 8.02 3.67 8.23 3.03" />
          <polygon style={{ fill: "#fff" }} points="9.96 5.63 10.16 6.27 10.83 6.27 10.29 6.69 10.49 7.35 9.96 6.96 9.42 7.36 9.63 6.69 9.09 6.27 9.75 6.27 9.96 5.63" />
          <polygon style={{ fill: "#fff" }} points="6.5 5.63 6.7 6.27 7.36 6.27 6.83 6.69 7.03 7.35 6.5 6.96 5.96 7.36 6.16 6.69 5.63 6.27 6.29 6.27 6.5 5.63" />
          <polygon style={{ fill: "#fff" }} points="3.03 5.63 3.24 6.27 3.9 6.27 3.36 6.69 3.57 7.35 3.03 6.96 2.5 7.36 2.7 6.69 2.17 6.27 2.83 6.27 3.03 5.63" />
          <polygon style={{ fill: "#fff" }} points="11.69 8.23 11.9 8.87 12.56 8.87 12.02 9.29 12.23 9.95 11.69 9.56 11.16 9.96 11.36 9.29 10.83 8.87 11.49 8.87 11.69 8.23" />
          <polygon style={{ fill: "#fff" }} points="8.23 8.23 8.43 8.87 9.09 8.87 8.56 9.29 8.76 9.95 8.23 9.56 7.69 9.96 7.9 9.29 7.36 8.87 8.02 8.87 8.23 8.23" />
          <polygon style={{ fill: "#fff" }} points="4.76 8.23 4.97 8.87 5.63 8.87 5.09 9.29 5.3 9.95 4.76 9.56 4.23 9.96 4.43 9.29 3.9 8.87 4.56 8.87 4.76 8.23" />
        </g>
      </g>
    </svg>
  )
}

export const IconDominicanRepublic = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path style={{ fill: "#c94847" }} d="M15.59.26v10.13h10.13C24.69,5.3,20.68,1.29,15.59.26Z" />
        <path style={{ fill: "#c94847" }} d="M10.39,25.72v-10.13H.26c1.03,5.09,5.04,9.1,10.13,10.13Z" />
        <path style={{ fill: "#2a5f9f" }} d="M15.59,15.59v10.13c5.09-1.03,9.1-5.04,10.13-10.13h-10.13Z" />
        <path style={{ fill: "#2a5f9f" }} d="M.26,10.39h10.13V.26C5.3,1.29,1.29,5.3.26,10.39Z" />

        <path
          style={{ fill: "#fafafa" }}
          d="M25.72,10.39h-10.13V.26c-.84-.17-1.71-.26-2.6-.26s-1.76.09-2.6.26v10.13H.26c-.17.84-.26,1.71-.26,2.6s.09,1.76.26,2.6h10.13v10.13c.84.17,1.71.26,2.6.26s1.76-.09,2.6-.26v-10.13h10.13c.17-.84.26-1.71.26-2.6s-.09-1.76-.26-2.6Z"
        />

        {/* Escudo (simplificado tal cual SVG original) */}
        <polygon style={{ fill: "#1f325b" }} points="12.71 12.65 12.71 11.37 11.39 11.37 11.72 11.71 11.72 12.65 12.71 12.65" />
        <polygon style={{ fill: "#ce1327" }} points="13.24 12.65 13.24 11.37 14.58 11.37 14.24 11.74 14.24 12.65 13.24 12.65" />
        <path style={{ fill: "#ce1327" }} d="M12.71,13.18h-1v.81c.04.35.3.47.54.47h.46v-1.27Z" />
        <path style={{ fill: "#1f325b" }} d="M13.24,13.18h1v.81c-.03.35-.31.47-.54.47h-.46v-1.28Z" />

        <polygon style={{ fill: "#eac106" }} points="12.86 11.29 12.86 11.58 12.57 11.58 12.57 11.82 12.86 11.82 12.86 12.85 13.1 12.85 13.1 11.82 13.39 11.82 13.39 11.58 13.1 11.58 13.1 11.29 12.86 11.29" />

        <polygon style={{ fill: "#201b19" }} points="12.09 13.07 13.25 12.4 13.88 13.31 12.66 14.1 12.09 13.07" />
        <polygon style={{ fill: "#cac9c9" }} points="12.23 12.85 13.21 12.28 13.74 13.05 12.71 13.71 12.23 12.85" />
      </g>
    </svg>
  )
}

export const IconBolivia = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        {/* Bandera */}
        <path style={{ fill: "#c94847" }} d="M12.99,0C7.33,0,2.53,3.62.74,8.66h24.5C23.45,3.62,18.65,0,12.99,0Z" />
        <path style={{ fill: "#ffce35" }} d="M.74,8.66c-.48,1.35-.74,2.81-.74,4.33s.26,2.98.74,4.33h24.5c.48-1.35.74-2.81.74-4.33s-.26-2.98-.74-4.33H.74Z" />
        <path style={{ fill: "#85be4f" }} d="M12.99,25.98c5.66,0,10.46-3.62,12.25-8.66H.74c1.78,5.04,6.59,8.66,12.25,8.66Z" />

        {/* Detalles centrales */}
        <circle style={{ fill: "#fff" }} cx="12.99" cy="10.54" r=".3" />
        <path style={{ fill: "#594640" }} d="M14.42,10.24c-.45,0-.96.51-1.43.51s-.98-.51-1.43-.51-2.15.51-2.15.51c2.39,0,3.58,1.28,3.58,1.28s1.19-1.28,3.58-1.28c0,0-1.7-.51-2.15-.51Z" />

        {/* Óvalo */}
        <path style={{ fill: "#07a6df" }} d="M12.99,11.42c1.01,0,1.83.95,1.83,2.12s-.82,2.12-1.83,2.12-1.83-.95-1.83-2.12.82-2.12,1.83-2.12Z" />
        <path style={{ fill: "#e8a30d" }} d="M14.49,13.61c0,.98-2.99.98-2.99,0s.67-1.77,1.5-1.77,1.5.79,1.5,1.77Z" />
        <path style={{ fill: "#d52c1e" }} d="M12.95,12.21c.4,0,.72.28.72.62s-.32.62-.72.62-.72-.28-.72-.62.32-.62.72-.62Z" />
        <path style={{ fill: "#689635" }} d="M12.91,12.68c-.45.01-1.42.95-1.42.95,0,.91.67,1.65,1.5,1.65s1.5-.74,1.5-1.65c0,0-1.09-.96-1.58-.95Z" />

        {/* Rectángulos inferiores */}
        <rect style={{ fill: "#e8a30d" }} x="13.13" y="14.3" width=".37" height=".63" />
        <rect style={{ fill: "#fff" }} x="13.67" y="13.61" width=".2" height="1.2" />
      </g>
    </svg>
  )
}

export const IconPeru = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path
            style={{ fill: "#e94d5c" }}
            d="M25.98,12.99c0-5.66-3.62-10.46-8.66-12.25v24.5c5.04-1.78,8.66-6.59,8.66-12.25Z"
          />
          <path
            style={{ fill: "#e94d5c" }}
            d="M0,12.99c0,5.66,3.62,10.46,8.66,12.25V.74C3.62,2.53,0,7.33,0,12.99Z"
          />
          <path
            style={{ fill: "#fafafa" }}
            d="M17.32.74c-1.35-.48-2.81-.74-4.33-.74s-2.98.26-4.33.74v24.5c1.35.48,2.81.74,4.33.74s2.98-.26,4.33-.74V.74Z"
          />
        </g>
      </g>
    </svg>
  )
}

export const IconCostaRica = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path
            style={{ fill: "#2a5f9f" }}
            d="M21.82,3.46c-2.32-2.15-5.42-3.46-8.83-3.46S6.48,1.32,4.16,3.46h17.66Z"
          />
          <path
            style={{ fill: "#2a5f9f" }}
            d="M4.16,22.52c2.32,2.15,5.42,3.46,8.83,3.46s6.51-1.32,8.83-3.46H4.16Z"
          />
          <path
            style={{ fill: "#c94847" }}
            d="M0,12.99c0,1.85.39,3.6,1.08,5.2h23.81c.7-1.59,1.08-3.35,1.08-5.2s-.39-3.6-1.08-5.2H1.08c-.7,1.59-1.08,3.35-1.08,5.2Z"
          />
          <path
            style={{ fill: "#fafafa" }}
            d="M4.17,22.52h17.64c1.31-1.21,2.36-2.68,3.09-4.33H1.08c.72,1.65,1.78,3.12,3.09,4.33Z"
          />
          <path
            style={{ fill: "#fafafa" }}
            d="M21.81,3.46H4.17c-1.3,1.21-2.36,2.68-3.09,4.33h23.82c-.72-1.65-1.78-3.12-3.09-4.33Z"
          />
        </g>
      </g>
    </svg>
  )
}

export const IconBrazil = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path
            style={{ fill: "#689635" }}
            d="M25.78,10.72C24.71,4.63,19.39,0,12.99,0S1.27,4.63.2,10.72l12.79-6.39,12.79,6.39Z"
          />
          <path
            style={{ fill: "#689635" }}
            d="M.2,15.26c1.07,6.09,6.39,10.72,12.79,10.72s11.72-4.63,12.79-10.72l-12.79,6.39L.2,15.26Z"
          />
          <path
            style={{ fill: "#ffe72d" }}
            d="M12.99,4.33L.2,10.72c-.13.74-.2,1.49-.2,2.27s.07,1.53.2,2.27l12.79,6.39,12.79-6.39c.13-.74.2-1.49.2-2.27s-.07-1.53-.2-2.27l-12.79-6.39Z"
          />
          <path
            style={{ fill: "#428bc1" }}
            d="M10.39,11.45c-1.37,0-2.67.3-3.85.81-.03.24-.04.49-.04.73,0,3.59,2.91,6.5,6.5,6.5,2.43,0,4.54-1.33,5.65-3.31-1.6-2.82-4.7-4.73-8.25-4.73Z"
          />
          <path
            style={{ fill: "#428bc1" }}
            d="M19.39,14.04c.06-.34.09-.69.09-1.05,0-3.59-2.91-6.5-6.5-6.5-2.56,0-4.78,1.49-5.83,3.65,1.02-.3,2.11-.47,3.23-.47,3.68,0,6.95,1.72,9,4.37Z"
          />
          <path
            style={{ fill: "#ffffff" }}
            d="M10.39,9.68c-1.12,0-2.21.17-3.23.47-.32.65-.53,1.36-.62,2.11,1.18-.51,2.48-.81,3.85-.81,3.56,0,6.65,1.92,8.25,4.73.37-.65.62-1.37.75-2.14-2.05-2.65-5.32-4.37-9-4.37Z"
          />
          <circle style={{ fill: "#ffffff" }} cx="8.66" cy="12.99" r=".43" />
          <circle style={{ fill: "#ffffff" }} cx="10.39" cy="15.59" r=".43" />
          <circle style={{ fill: "#ffffff" }} cx="12.99" cy="15.59" r=".43" />
          <circle style={{ fill: "#ffffff" }} cx="12.99" cy="17.32" r=".43" />
          <circle style={{ fill: "#ffffff" }} cx="16.45" cy="15.59" r=".43" />
          <circle style={{ fill: "#ffffff" }} cx="16.45" cy="17.32" r=".43" />
          <circle style={{ fill: "#ffffff" }} cx="14.72" cy="16.45" r=".43" />
          <circle style={{ fill: "#ffffff" }} cx="8.66" cy="14.72" r=".43" />
        </g>
      </g>
    </svg>
  )
}

export const IconMexico = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path
            style={{ fill: "#e94d5c" }}
            d="M25.98,12.99c0-5.66-3.62-10.46-8.66-12.25v24.5c5.04-1.78,8.66-6.59,8.66-12.25Z"
          />
          <path
            style={{ fill: "#74a843" }}
            d="M0,12.99c0,5.66,3.62,10.46,8.66,12.25V.74C3.62,2.53,0,7.34,0,12.99Z"
          />
          <path
            style={{ fill: "#ffffff" }}
            d="M17.32.74c-1.35-.48-2.81-.74-4.33-.74s-2.98.26-4.33.74v24.5c1.35.48,2.81.74,4.33.74s2.98-.26,4.33-.74V.74Z"
          />

          <path style={{ fill: "#74a843" }} d="M16.78,12.84c-.03-.11-.07.03-.07.09-.02-.11-.05-.23-.12-.33-.13.13-.16.29-.17.47-.03-.13-.08-.26-.21-.31.07.12.05.21.03.34-.02.19.13.3.14.49,0,.19-.08.31-.21.42.01-.04.01-.09.02-.13-.44.15-.35.41-.33.76.02.38-.21.31-.48.51.04-.1.04-.2,0-.29-.02.24-.33.28-.4.5-.03.11-.02.24-.11.32-.08.05-.21.12-.23.23-.1-.05-.19-.05-.29-.03.05-.03.09-.06.12-.1-.44-.2-.57.24-.94.31-.12,0-.43-.17-.44,0,.37,0,.57.34.89.35.27,0,.48-.24.75-.24-.02-.02-.17-.08-.28-.08.2-.12.34-.4.59-.4.45,0,.64-.1.79-.51-.05,0-.09,0-.13.03,0-.19.19-.38.34-.48.45-.08.37-.45.64-.72-.11,0-.18.06-.26.13.02-.26-.06-.5.19-.68.34-.24.29-.32.21-.66Z" />
          <path style={{ fill: "#74a843" }} d="M9.2,12.84c-.08.33-.13.41.21.66.25.18.17.42.19.68-.08-.08-.15-.13-.26-.13.27.27.19.64.64.72.15.11.34.29.34.48-.04-.02-.09-.03-.13-.03.15.41.34.51.79.51.25,0,.39.28.59.4-.11,0-.26.06-.28.08.27,0,.48.25.75.24.32,0,.52-.35.89-.35-.01-.18-.32-.02-.44,0-.37-.07-.5-.51-.94-.31.03.04.07.08.12.1-.1-.02-.2-.02-.29.03-.02-.1-.15-.17-.23-.23-.1-.08-.08-.21-.11-.32-.07-.22-.38-.25-.4-.49-.05.09-.05.2,0,.29-.26-.2-.49-.13-.48-.51.02-.36.1-.61-.33-.76.01.04,0,.09.02.13-.14-.11-.22-.24-.21-.42,0-.19.16-.3.14-.49-.01-.13-.04-.22.03-.34-.13.05-.18.18-.21.31-.01-.17-.05-.34-.17-.47-.06.1-.1.21-.12.33,0-.06-.04-.2-.07-.09Z" />

          <path
            style={{ fill: "#428bc1" }}
            d="M14.14,15.44c-.07-.02-.13-.06-.16-.13.02-.09.33-.16.41-.17,0-.04,0-.07,0-.1-.58.18-2.26.28-2.6-.3-.19.24-.47.07-.8-.13.06.08.23.52.2.47.09.03.65.16.66.29-.03.06-.08.1-.14.11.94.35,1.49.44,2.43-.04Z"
          />
          <path
            style={{ fill: "#e94d5c" }}
            d="M13.58,15.46c.03-.04.06-.1.06-.16,0-.02-.03-.11-.03-.12.09-.1.02-.32-.14-.24-.07.03-.04.05-.12.01-.03-.01-.05-.03-.08-.03-.11,0-.21-.01-.32-.02-.09,0-.21,0-.31,0-.06,0-.13,0-.19,0-.07,0-.1-.02-.15-.05-.08-.03-.14.03-.16.11-.02.07.06.09.06.15,0,.04-.06.1-.06.16,0,.07.04.13.08.18-.18.15.02.36.16.2.04.1.19.09.28.09.15,0,.31,0,.47,0,.09,0,.27.02.32-.07.16.13.3-.15.13-.23Z"
          />
        </g>
      </g>
    </svg>
  )
}

export const IconPanama = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          {/* Cuadrantes */}
          <path
            style={{ fill: "#e94d5c" }}
            d="M12.99,0v12.99h12.99C25.98,5.82,20.16,0,12.99,0Z"
          />
          <path
            style={{ fill: "#2a5f9f" }}
            d="M12.99,25.98v-12.99H0c0,7.17,5.82,12.99,12.99,12.99Z"
          />
          <path
            style={{ fill: "#fafafa" }}
            d="M12.99,25.98v-12.99h12.99c0,7.17-5.82,12.99-12.99,12.99Z"
          />
          <path
            style={{ fill: "#fafafa" }}
            d="M12.99,0v12.99H0C0,5.82,5.82,0,12.99,0Z"
          />

          {/* Estrellas */}
          <polygon
            style={{ fill: "#2a5f9f" }}
            points="6.5 8.08 7.83 9.09 7.33 7.44 8.66 6.39 7.01 6.39 6.5 4.76 6 6.39 4.33 6.39 5.66 7.44 5.16 9.09 6.5 8.08"
          />
          <polygon
            style={{ fill: "#e94d5c" }}
            points="19.49 19.34 20.82 20.35 20.32 18.7 21.65 17.64 20 17.64 19.49 16.02 18.99 17.64 17.32 17.64 18.65 18.7 18.15 20.35 19.49 19.34"
          />
        </g>
      </g>
    </svg>
  )
}

export const IconCuba = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          {/* Franjas blancas */}
          <path
            style={{ fill: "#fafafa" }}
            d="M3.8,10.39h21.91c-.39-1.92-1.2-3.69-2.34-5.2H3.8v5.2Z"
          />
          <path
            style={{ fill: "#fafafa" }}
            d="M3.8,15.59v5.2h19.58c1.13-1.51,1.95-3.28,2.34-5.2H3.8Z"
          />

          {/* Franjas azules */}
          <path
            style={{ fill: "#428bc1" }}
            d="M25.72,10.39H3.8v5.2h21.91c.17-.84.26-1.71.26-2.6s-.09-1.76-.26-2.6Z"
          />
          <path
            style={{ fill: "#428bc1" }}
            d="M3.8,5.2h19.58C21.01,2.04,17.24,0,12.99,0c-3.59,0-6.83,1.46-9.19,3.81v1.38Z"
          />
          <path
            style={{ fill: "#428bc1" }}
            d="M3.8,20.78v1.38c2.35,2.35,5.6,3.81,9.19,3.81,4.25,0,8.02-2.04,10.39-5.2H3.8Z"
          />

          {/* Triángulo rojo */}
          <path
            style={{ fill: "#e94d5c" }}
            d="M3.8,3.8C1.45,6.16,0,9.4,0,12.99s1.45,6.83,3.8,9.19l9.19-9.19L3.8,3.8Z"
          />

          {/* Estrella */}
          <polygon
            style={{ fill: "#fafafa" }}
            points="3.46 15.59 5.2 14.37 6.93 15.59 6.28 13.61 8.01 12.34 5.86 12.34 5.2 10.39 4.55 12.34 2.38 12.34 4.11 13.61 3.46 15.59"
          />
        </g>
      </g>
    </svg>
  )
}

export const IconNicaragua = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="nicaragua-red-gradient"
          x1="-516.03"
          y1="-1432.52"
          x2="-513.72"
          y2="-1432.52"
          gradientTransform="translate(491.23 4.89) rotate(69.3) scale(.31 -.31)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e73635" />
          <stop offset="0.51" stopColor="#e52927" />
          <stop offset="1" stopColor="#e52320" />
        </linearGradient>
      </defs>

      <g>
        {/* Azul superior */}
        <path
          style={{ fill: "#428bc1" }}
          d="M12.99,0C7.33,0,2.53,3.62.74,8.66h24.5C23.45,3.62,18.65,0,12.99,0Z"
        />

        {/* Azul inferior */}
        <path
          style={{ fill: "#428bc1" }}
          d="M12.99,25.98c5.66,0,10.46-3.62,12.25-8.66H.74c1.78,5.04,6.59,8.66,12.25,8.66Z"
        />

        {/* Blanco central */}
        <path
          style={{ fill: "#fafafa" }}
          d="M.74,8.66c-.48,1.35-.74,2.81-.74,4.33s.26,2.98.74,4.33h24.5c.48-1.35.74-2.81.74-4.33s-.26-2.98-.74-4.33H.74Z"
        />

        {/* Triángulo */}
        <polygon
          style={{ fill: "#43ade2" }}
          points="12.99 10.11 10.27 14.45 15.71 14.45 12.99 10.11"
        />
        <polygon
          style={{ fill: "#428bc1" }}
          points="11.63 12.28 10.27 14.45 15.71 14.45 14.35 12.28 11.63 12.28"
        />

        {/* Detalle rojo con degradado */}
        <path
          style={{ fill: "url(#nicaragua-red-gradient)" }}
          d="M13.4,12.56c.01-.04,0-.1,0-.13,0-.14-.1-.31-.2-.47-.1-.17-.23-.21-.44-.09-.09.05-.14.1-.19.2-.02.04-.02.09,0,.12.01.01.07.03.12-.03.02-.02.05-.03.06-.03-.04.03-.1.1-.12.16-.03.06-.04.15-.03.15,0,0,.04.07.14.11.08.03.13.08.18.12.05.04.04.07.04.17,0,.04,0,.14.05.15.05.02.09-.03.11-.11.02-.07.04-.12.06-.16.04-.02.06-.06.13-.05.05,0,.08,0,.1-.03,0-.04-.03-.07-.02-.13Z"
        />

        {/* Verde */}
        <path
          style={{ fill: "#85be4f" }}
          d="M15.42,14.03c-.44-.06-.81-.44-.92-.81-.05.15-.13.3-.25.43-.12-.13-.2-.28-.25-.43-.05.15-.13.3-.25.43-.12-.13-.2-.28-.25-.43-.05.15-.13.3-.25.43-.11-.13-.2-.28-.25-.43-.12.37-.54.86-.98.92l-.22.32h5.42l-.28-.42Z"
        />

        {/* Borde dorado */}
        <path
          style={{ fill: "#dbb470" }}
          d="M12.99,16.24c-1.79,0-3.25-1.45-3.25-3.25s1.45-3.25,3.25-3.25,3.25,1.45,3.25,3.25-1.45,3.25-3.25,3.25ZM12.99,9.09c-2.15,0-3.9,1.74-3.9,3.9s1.74,3.9,3.9,3.9,3.9-1.74,3.9-3.9-1.74-3.9-3.9-3.9Z"
        />
      </g>
    </svg>
  )
}

export const IconVenezuela = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        {/* Amarillo */}
        <path
          style={{ fill: "#ffe72d" }}
          d="M12.99,0C7.33,0,2.53,3.62.74,8.66h24.5C23.45,3.62,18.65,0,12.99,0Z"
        />

        {/* Rojo */}
        <path
          style={{ fill: "#e94d5c" }}
          d="M12.99,25.98c5.66,0,10.46-3.62,12.25-8.66H.74c1.78,5.04,6.59,8.66,12.25,8.66Z"
        />

        {/* Azul */}
        <path
          style={{ fill: "#2a5f9f" }}
          d="M.74,8.66c-.48,1.35-.74,2.81-.74,4.33s.26,2.98.74,4.33h24.5c.48-1.35.74-2.81.74-4.33s-.26-2.98-.74-4.33H.74Z"
        />

        {/* Estrellas */}
        <polygon style={{ fill: "#fff" }} points="14.1 10.89 14.55 11.34 14.46 10.71 15.05 10.43 14.41 10.32 14.32 9.69 14.01 10.25 13.37 10.15 13.82 10.6 13.51 11.17 14.1 10.89" />
        <polygon style={{ fill: "#fff" }} points="11.76 10.9 12.36 11.17 12.03 10.61 12.47 10.15 11.83 10.26 11.5 9.7 11.44 10.34 10.8 10.45 11.39 10.73 11.33 11.36 11.76 10.9" />
        <polygon style={{ fill: "#fff" }} points="9.6 11.7 10.26 11.76 9.74 11.34 9.96 10.76 9.42 11.08 8.9 10.67 9.08 11.28 8.53 11.61 9.19 11.67 9.37 12.28 9.6 11.7" />
        <polygon style={{ fill: "#fff" }} points="7.9 13.18 8.53 13.01 7.89 12.8 7.87 12.18 7.49 12.67 6.85 12.46 7.25 12.97 6.87 13.46 7.5 13.29 7.91 13.8 7.9 13.18" />
        <polygon style={{ fill: "#fff" }} points="6.89 15.15 7.41 14.77 6.73 14.79 6.48 14.22 6.31 14.8 5.63 14.82 6.2 15.16 6.04 15.75 6.56 15.38 7.14 15.72 6.89 15.15" />
        <polygon style={{ fill: "#fff" }} points="19.11 15.08 18.87 15.66 19.44 15.31 19.97 15.67 19.79 15.09 20.35 14.74 19.67 14.73 19.48 14.14 19.25 14.72 18.57 14.71 19.11 15.08" />
        <polygon style={{ fill: "#fff" }} points="18.03 13.13 18.04 13.75 18.43 13.23 19.07 13.39 18.68 12.91 19.06 12.39 18.43 12.61 18.03 12.12 18.03 12.74 17.4 12.96 18.03 13.13" />
        <polygon style={{ fill: "#fff" }} points="16.29 11.66 16.53 12.24 16.69 11.63 17.35 11.56 16.8 11.24 16.96 10.63 16.45 11.04 15.89 10.73 16.13 11.31 15.63 11.73 16.29 11.66" />
      </g>
    </svg>
  )
}

export const IconElSalvador = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        {/* Azul superior */}
        <path
          style={{ fill: "#428bc1" }}
          d="M12.99,0C7.33,0,2.53,3.62.74,8.66h24.5C23.45,3.62,18.65,0,12.99,0Z"
        />

        {/* Azul inferior */}
        <path
          style={{ fill: "#428bc1" }}
          d="M12.99,25.98c5.66,0,10.46-3.62,12.25-8.66H.74c1.78,5.04,6.59,8.66,12.25,8.66Z"
        />

        {/* Blanco central */}
        <path
          style={{ fill: "#fafafa" }}
          d="M.74,8.66c-.48,1.35-.74,2.81-.74,4.33s.26,2.98.74,4.33h24.5c.48-1.35.74-2.81.74-4.33s-.26-2.98-.74-4.33H.74Z"
        />

        {/* Emblema */}
        <path
          style={{ fill: "#428bc1" }}
          d="M14.53,11.23l-.52.52c.17.22.28.5.28.8a1.3,1.3,0,1,1-2.6,0c0-.3.1-.58.28-.8l-.52-.52a1.99,1.99,0,1,0,3.08,0Z"
        />

        <path
          style={{ fill: "#428bc1" }}
          d="M13.87,10.13l-.3.3c.1.13.16.29.16.46a.75.75,0,1,1-1.5,0c0-.17.06-.33.16-.46l-.3-.3a1.15,1.15,0,1,0,1.78,0Z"
        />

        {/* Laurel izquierdo */}
        <path style={{ fill: "#689635" }} d="M11.41 11.91c-.2-.07-.39-.06-.39-.06.14-.21.18-.6.18-.6-.13.06-.35.21-.47.41-.07-.15-.2-.3-.2-.3-.08.09-.15.22-.14.35.02.17.25.43.25.43s.33.1.5.05c.17-.05.27-.27.27-.27Z" />
        <path style={{ fill: "#85be4f" }} d="M11.1 12.41c-.16 0-.39.04-.39.04.08-.24.02-.63.02-.63-.09.09-.27.28-.35.51-.11-.13-.28-.24-.28-.24-.05.1-.1.26-.04.38.07.16.35.36.35.36s.34 0 .49-.08c.15-.09.19-.33.19-.33Z" />

        {/* Laurel derecho */}
        <path style={{ fill: "#689635" }} d="M14.57 11.91c.2-.07.39-.06.39-.06-.14-.21-.18-.6-.18-.6.13.06.35.21.47.41.07-.15.2-.3.2-.3.08.09.15.22.14.35-.02.17-.25.43-.25.43s-.33.1-.5.05c-.17-.05-.27-.27-.27-.27Z" />
        <path style={{ fill: "#85be4f" }} d="M14.88 12.41c.16 0 .39.04.39.04-.08-.24-.02-.63-.02-.63.09.09.27.28.35.51.11-.13.28-.24.28-.24.05.1.1.26.04.38-.07.16-.35.36-.35.36s-.34 0-.49-.08c-.15-.09-.19-.33-.19-.33Z" />

        {/* Triángulo */}
        <path
          style={{ fill: "#ffce35" }}
          d="M11.19,14.25h3.61l-1.8-3.01-1.8,3.01Zm4.4.46h-5.2l2.6-4.33,2.6,4.33Z"
        />

        {/* Centro */}
        <polygon
          style={{ fill: "#3e4347" }}
          points="13.21 12.19 12.99 12.54 12.77 12.19 12.77 11.16 12.99 10.81 13.21 11.16 13.21 12.19"
        />

        <circle style={{ fill: "#c94847" }} cx="12.99" cy="12.54" r="0.87" />

        <path
          style={{ fill: "#f8c5ce" }}
          d="M12.99,11.89a.65.65,0,0,0-.65.65h1.3a.65.65,0,0,0-.65-.65Z"
        />

        {/* Borde dorado */}
        <path
          style={{ fill: "#ffcc03" }}
          d="M17.2,13.17A4.21,4.21,0,1,0,11.44,16.95l.3-.52a3.61,3.61,0,1,1,3.75,0l.21.56A4.21,4.21,0,0,0,17.2,13.17Z"
        />
      </g>
    </svg>
  )
}

export const IconGuatemala = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        {/* Franjas celestes */}
        <path
          style={{ fill: "#43ade2" }}
          d="M25.98,12.99c0-5.66-3.62-10.46-8.66-12.25v24.5c5.04-1.78,8.66-6.59,8.66-12.25Z"
        />
        <path
          style={{ fill: "#43ade2" }}
          d="M0,12.99c0,5.66,3.62,10.46,8.66,12.25V.74C3.62,2.53,0,7.33,0,12.99Z"
        />

        {/* Franja blanca */}
        <path
          style={{ fill: "#fafafa" }}
          d="M17.32.74c-1.35-.48-2.81-.74-4.33-.74s-2.98.26-4.33.74v24.5c1.35.48,2.81.74,4.33.74s2.98-.26,4.33-.74V.74Z"
        />

        {/* Laurel izquierdo */}
        <path style={{ fill: "#689635" }} d="M10.85,10.36s-.29-.08-.53-.08c0,0,0,0,0-.01.19-.28.25-.81.25-.81,0,0-.46.27-.65.55-.1-.2-.27-.41-.27-.41,0,0-.22.24-.18.48.03.24.33.59.33.59,0,0,.45.13.68.06.23-.07.37-.36.37-.36Z" />
        <path style={{ fill: "#85be4f" }} d="M10.42,11.04s-.31,0-.53.06c0,0,0,0,0-.01.11-.32.03-.85.03-.85,0,0-.37.38-.48.7-.15-.17-.37-.33-.37-.33,0,0-.15.29-.05.51.09.22.48.48.48.48,0,0,.47.01.67-.11.21-.12.26-.44.26-.44Z" />
        <path style={{ fill: "#689635" }} d="M10.19,11.81s-.3.07-.5.19c0,0,0,0,0-.01.02-.34-.2-.83-.2-.83,0,0-.26.46-.28.8-.19-.13-.45-.22-.45-.22,0,0-.06.32.08.51.15.19.59.34.59.34,0,0,.45-.11.62-.28.17-.17.13-.5.13-.5Z" />
        <path style={{ fill: "#85be4f" }} d="M10.16,12.61s-.27.15-.43.32c0,0,0,0,0-.01-.07-.33-.41-.75-.41-.75,0,0-.13.51-.06.84-.21-.08-.49-.1-.49-.1,0,0,.02.32.21.47.19.14.66.18.66.18,0,0,.41-.22.52-.43.12-.21,0-.51,0-.51Z" />

        {/* Laurel derecho */}
        <path style={{ fill: "#689635" }} d="M15.13,10.36s.29-.08.53-.08c0,0,0,0,0-.01-.19-.28-.25-.81-.25-.81,0,0,.46.27.65.55.1-.2.28-.41.28-.41,0,0,.22.24.18.48-.03.24-.33.59-.33.59,0,0-.45.13-.68.06-.23-.07-.37-.36-.37-.36Z" />
        <path style={{ fill: "#85be4f" }} d="M15.56,11.04s.31,0,.53.06c0,0,0,0,0-.01-.11-.32-.03-.85-.03-.85,0,0,.37.38.48.7.15-.17.37-.33.37-.33,0,0,.15.29.05.51-.09.22-.48.48-.48.48,0,0-.47.01-.67-.11-.21-.12-.26-.44-.26-.44Z" />

        {/* Rifles */}
        <polygon style={{ fill: "#95989b" }} points="16.45 9.56 10.39 15.15 10.9 15.62 16.45 9.56" />
        <polygon style={{ fill: "#95989b" }} points="9.53 9.56 15.59 15.15 15.08 15.62 9.53 9.56" />

        {/* Pergamino */}
        <path
          style={{ fill: "#ffdd7e" }}
          d="M11.77,13.42h1.73s.43-.43.43-1.73-.43-1.73-.43-1.73h-1.73s.43.43.43,1.73-.43,1.73-.43,1.73Z"
        />

        {/* Detalles cafés */}
        <path style={{ fill: "#594640" }} d="M10.14,16.41c-.14.14-.37.14-.51,0-.14-.14-.14-.37,0-.51l1.01-1.01c.14-.14.37-.14.51,0,.14.14.14.37,0,.51l-1.01,1.01Z" />
        <path style={{ fill: "#594640" }} d="M15.84,16.41c.14.14.37.14.51,0,.14-.14.14-.37,0-.51l-1.01-1.01c-.14-.14-.37-.14-.51,0-.14.14-.14.37,0,.51l1.01,1.01Z" />
      </g>
    </svg>
  )
}

export const IconUruguay = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        {/* Fondo blanco */}
        <path
          style={{ fill: "#fafafa" }}
          d="M25.85,11.26h-.62v-2.59c-.44-1.26-1.07-2.43-1.86-3.47h-2.6v-2.6c-2.17-1.63-4.87-2.6-7.79-2.6C5.82,0,0,5.82,0,12.99c0,.59.05,1.16.13,1.73h.62v2.59c.44,1.26,1.07,2.43,1.86,3.47h2.6v2.6c2.17,1.63,4.87,2.6,7.79,2.6s5.62-.97,7.79-2.61v-2.59h2.59c.78-1.04,1.42-2.21,1.86-3.46v-2.6h.62c.08-.57.12-1.14.12-1.73s-.05-1.16-.13-1.73Z"
        />

        {/* Franjas azules */}
        <path style={{ fill: "#428bc1" }} d="M.74,17.32h24.5c.29-.83.5-1.7.62-2.6H.12c.12.9.33,1.77.62,2.6Z" />
        <path style={{ fill: "#428bc1" }} d="M2.6,20.78c.74.98,1.61,1.86,2.6,2.6h15.59c.98-.74,1.86-1.61,2.6-2.6H2.6Z" />
        <path style={{ fill: "#428bc1" }} d="M12.99,5.2h10.39c-.74-.98-1.61-1.86-2.6-2.6h-7.79v2.6Z" />
        <path style={{ fill: "#428bc1" }} d="M12.99,11.26h12.87c-.12-.9-.33-1.77-.62-2.6h-12.25v2.6Z" />

        {/* Sol */}
        <path style={{ fill: "#fdd217" }} d="M6.36,9.87l-.59.41c-.34.81-.23,1.19-.19,1.49l-.3.73c1.15-.38.16-1.07,1.78-2.24l-.39-.59-.3.21Z" />
        <path style={{ fill: "#fdd217" }} d="M6.01,9.21l-.7-.13c-.81.34-1,.68-1.18.92l-.73.3c1.08.55.87-.64,2.85-.33l.14-.7Z" />
        <path style={{ fill: "#fdd217" }} d="M5.27,8.79l.59-.39-.41-.59c-.81-.34-1.19-.23-1.49-.19l-.73-.3c.38,1.15,1.07.16,2.24,1.78Z" />
        <path style={{ fill: "#fdd217" }} d="M5.66,7.55l.7.14.13-.7c-.34-.81-.68-1-.92-1.18l-.3-.73c-.55,1.08.64.87.33,2.85Z" />
        <path style={{ fill: "#fdd217" }} d="M8.59,4.78c-1.15.38-.16,1.07-1.78,2.25l.39.59.9-.62c.6-1.45-.23-1.51.49-2.21Z" />

        {/* Estrella */}
        <polygon
          style={{ fill: "#fdd217" }}
          points="8.25 9.21 11.26 8.66 8.25 8.11 9.99 5.6 7.48 7.34 6.93 4.33 6.38 7.34 3.87 5.6 5.61 8.11 2.6 8.66 5.61 9.21 3.87 11.72 6.38 9.98 6.93 12.99 7.48 9.98 9.99 11.72 8.25 9.21"
        />

        {/* Centro */}
        <circle style={{ fill: "#fdd217" }} cx="6.93" cy="8.66" r="1.44" />
      </g>
    </svg>
  )
}

export const IconPuertoRico = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path style={{ fill: "#fff" }} d="M3.8,10.39h21.91c-.39-1.92-1.2-3.69-2.34-5.2H3.8v5.2Z" />
          <path style={{ fill: "#fff" }} d="M3.8,15.59v5.2h19.58c1.13-1.51,1.95-3.28,2.34-5.2H3.8Z" />
          <path style={{ fill: "#e94d5c" }} d="M25.72,10.39H3.8v5.2h21.91c.17-.84.26-1.71.26-2.6s-.09-1.76-.26-2.6Z" />
          <path style={{ fill: "#e94d5c" }} d="M3.8,5.2h19.58C21.01,2.04,17.24,0,12.99,0c-3.59,0-6.83,1.46-9.19,3.81v1.38Z" />
          <path style={{ fill: "#e94d5c" }} d="M3.8,20.78v1.38c2.35,2.35,5.6,3.81,9.19,3.81,4.25,0,8.02-2.04,10.39-5.2H3.8Z" />
          <path style={{ fill: "#428bc1" }} d="M3.8,3.81C1.45,6.16,0,9.4,0,12.99s1.45,6.83,3.8,9.19l9.19-9.19L3.8,3.81Z" />
          <polygon style={{ fill: "#fff" }} points="3.46 15.59 5.2 14.37 6.93 15.59 6.28 13.61 8.01 12.34 5.86 12.34 5.2 10.39 4.55 12.34 2.38 12.34 4.11 13.61 3.46 15.59" />
        </g>
      </g>
    </svg>
  )
}

export const IconChile = ({
  width = "24",
  height = "24",
  color = "",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 25.98 25.98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Capa_1-2" data-name="Capa 1">
        <g>
          <path style={{ fill: "#e94d5c" }} d="M0,12.99c0,7.17,5.82,12.99,12.99,12.99s12.99-5.82,12.99-12.99H0Z" />
          <path style={{ fill: "#fafafa" }} d="M12.99,0c7.17,0,12.99,5.82,12.99,12.99h-12.99V0Z" />
          <path style={{ fill: "#2a5f9f" }} d="M12.99,0C5.82,0,0,5.82,0,12.99h12.99V0Z" />
          <polygon style={{ fill: "#fafafa" }} points="7.79 8.54 9.93 9.96 9.13 7.65 11.26 6.17 8.62 6.17 7.79 3.9 6.99 6.17 4.33 6.17 6.46 7.65 5.65 9.96 7.79 8.54" />
        </g>
      </g>
    </svg>
  )
}